(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode("._NavBarContainer_e4224_1{display:flex;justify-content:space-between;padding:10px 20px;background-color:var(--color-navbar-bg);border-bottom:1px solid var(--color-navbar-border)}._AppTitle_e4224_9{font-weight:700;font-size:18px;flex-grow:1;margin:1em 2em}._NavBarActions_e4224_16{display:flex;align-items:center;gap:1em}._IconButton_e4224_22{background-color:transparent;border:none;cursor:pointer;color:var(--color-navbar-icon-button);fill:currentColor}._IconButton_e4224_22:hover{color:var(--color-navbar-icon-button-hover)}._IconButton_e4224_22:active{transform:translate(1px,1px)}")),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import * as O from "react";
import go, { createContext as Ot, useRef as ut, useLayoutEffect as yo, useEffect as yn, useId as vn, useContext as W, useInsertionEffect as Oi, useCallback as xn, useMemo as wt, Children as vo, isValidElement as xo, useState as qe, forwardRef as To, Fragment as Fi, createElement as bo, Component as wo } from "react";
var de = { exports: {} }, zt = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ds;
function Po() {
  if (ds) return zt;
  ds = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.fragment");
  function n(s, i, o) {
    var r = null;
    if (o !== void 0 && (r = "" + o), i.key !== void 0 && (r = "" + i.key), "key" in i) {
      o = {};
      for (var a in i)
        a !== "key" && (o[a] = i[a]);
    } else o = i;
    return i = o.ref, {
      $$typeof: t,
      type: s,
      key: r,
      ref: i !== void 0 ? i : null,
      props: o
    };
  }
  return zt.Fragment = e, zt.jsx = n, zt.jsxs = n, zt;
}
var Wt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ms;
function So() {
  return ms || (ms = 1, process.env.NODE_ENV !== "production" && function() {
    function t(f) {
      if (f == null) return null;
      if (typeof f == "function")
        return f.$$typeof === Z ? null : f.displayName || f.name || null;
      if (typeof f == "string") return f;
      switch (f) {
        case A:
          return "Fragment";
        case x:
          return "Portal";
        case C:
          return "Profiler";
        case D:
          return "StrictMode";
        case St:
          return "Suspense";
        case _t:
          return "SuspenseList";
      }
      if (typeof f == "object")
        switch (typeof f.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), f.$$typeof) {
          case _:
            return (f.displayName || "Context") + ".Provider";
          case I:
            return (f._context.displayName || "Context") + ".Consumer";
          case tt:
            var b = f.render;
            return f = f.displayName, f || (f = b.displayName || b.name || "", f = f !== "" ? "ForwardRef(" + f + ")" : "ForwardRef"), f;
          case At:
            return b = f.displayName || null, b !== null ? b : t(f.type) || "Memo";
          case he:
            b = f._payload, f = f._init;
            try {
              return t(f(b));
            } catch {
            }
        }
      return null;
    }
    function e(f) {
      return "" + f;
    }
    function n(f) {
      try {
        e(f);
        var b = !1;
      } catch {
        b = !0;
      }
      if (b) {
        b = console;
        var w = b.error, R = typeof Symbol == "function" && Symbol.toStringTag && f[Symbol.toStringTag] || f.constructor.name || "Object";
        return w.call(
          b,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          R
        ), e(f);
      }
    }
    function s() {
    }
    function i() {
      if (Ut === 0) {
        es = console.log, ns = console.info, ss = console.warn, is = console.error, rs = console.group, os = console.groupCollapsed, as = console.groupEnd;
        var f = {
          configurable: !0,
          enumerable: !0,
          value: s,
          writable: !0
        };
        Object.defineProperties(console, {
          info: f,
          log: f,
          warn: f,
          error: f,
          group: f,
          groupCollapsed: f,
          groupEnd: f
        });
      }
      Ut++;
    }
    function o() {
      if (Ut--, Ut === 0) {
        var f = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: pt({}, f, { value: es }),
          info: pt({}, f, { value: ns }),
          warn: pt({}, f, { value: ss }),
          error: pt({}, f, { value: is }),
          group: pt({}, f, { value: rs }),
          groupCollapsed: pt({}, f, { value: os }),
          groupEnd: pt({}, f, { value: as })
        });
      }
      0 > Ut && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function r(f) {
      if (ke === void 0)
        try {
          throw Error();
        } catch (w) {
          var b = w.stack.trim().match(/\n( *(at )?)/);
          ke = b && b[1] || "", ls = -1 < w.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < w.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + ke + f + ls;
    }
    function a(f, b) {
      if (!f || je) return "";
      var w = Be.get(f);
      if (w !== void 0) return w;
      je = !0, w = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var R = null;
      R = J.H, J.H = null, i();
      try {
        var $ = {
          DetermineComponentFrameRoot: function() {
            try {
              if (b) {
                var lt = function() {
                  throw Error();
                };
                if (Object.defineProperty(lt.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(lt, []);
                  } catch (rt) {
                    var fe = rt;
                  }
                  Reflect.construct(f, [], lt);
                } else {
                  try {
                    lt.call();
                  } catch (rt) {
                    fe = rt;
                  }
                  f.call(lt.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (rt) {
                  fe = rt;
                }
                (lt = f()) && typeof lt.catch == "function" && lt.catch(function() {
                });
              }
            } catch (rt) {
              if (rt && fe && typeof rt.stack == "string")
                return [rt.stack, fe.stack];
            }
            return [null, null];
          }
        };
        $.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var k = Object.getOwnPropertyDescriptor(
          $.DetermineComponentFrameRoot,
          "name"
        );
        k && k.configurable && Object.defineProperty(
          $.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var E = $.DetermineComponentFrameRoot(), it = E[0], Et = E[1];
        if (it && Et) {
          var K = it.split(`
`), gt = Et.split(`
`);
          for (E = k = 0; k < K.length && !K[k].includes(
            "DetermineComponentFrameRoot"
          ); )
            k++;
          for (; E < gt.length && !gt[E].includes(
            "DetermineComponentFrameRoot"
          ); )
            E++;
          if (k === K.length || E === gt.length)
            for (k = K.length - 1, E = gt.length - 1; 1 <= k && 0 <= E && K[k] !== gt[E]; )
              E--;
          for (; 1 <= k && 0 <= E; k--, E--)
            if (K[k] !== gt[E]) {
              if (k !== 1 || E !== 1)
                do
                  if (k--, E--, 0 > E || K[k] !== gt[E]) {
                    var $t = `
` + K[k].replace(
                      " at new ",
                      " at "
                    );
                    return f.displayName && $t.includes("<anonymous>") && ($t = $t.replace("<anonymous>", f.displayName)), typeof f == "function" && Be.set(f, $t), $t;
                  }
                while (1 <= k && 0 <= E);
              break;
            }
        }
      } finally {
        je = !1, J.H = R, o(), Error.prepareStackTrace = w;
      }
      return K = (K = f ? f.displayName || f.name : "") ? r(K) : "", typeof f == "function" && Be.set(f, K), K;
    }
    function l(f) {
      if (f == null) return "";
      if (typeof f == "function") {
        var b = f.prototype;
        return a(
          f,
          !(!b || !b.isReactComponent)
        );
      }
      if (typeof f == "string") return r(f);
      switch (f) {
        case St:
          return r("Suspense");
        case _t:
          return r("SuspenseList");
      }
      if (typeof f == "object")
        switch (f.$$typeof) {
          case tt:
            return f = a(f.render, !1), f;
          case At:
            return l(f.type);
          case he:
            b = f._payload, f = f._init;
            try {
              return l(f(b));
            } catch {
            }
        }
      return "";
    }
    function c() {
      var f = J.A;
      return f === null ? null : f.getOwner();
    }
    function u(f) {
      if (Ct.call(f, "key")) {
        var b = Object.getOwnPropertyDescriptor(f, "key").get;
        if (b && b.isReactWarning) return !1;
      }
      return f.key !== void 0;
    }
    function h(f, b) {
      function w() {
        cs || (cs = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          b
        ));
      }
      w.isReactWarning = !0, Object.defineProperty(f, "key", {
        get: w,
        configurable: !0
      });
    }
    function d() {
      var f = t(this.type);
      return us[f] || (us[f] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), f = this.props.ref, f !== void 0 ? f : null;
    }
    function m(f, b, w, R, $, k) {
      return w = k.ref, f = {
        $$typeof: M,
        type: f,
        key: b,
        props: k,
        _owner: $
      }, (w !== void 0 ? w : null) !== null ? Object.defineProperty(f, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(f, "ref", { enumerable: !1, value: null }), f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(f, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    }
    function p(f, b, w, R, $, k) {
      if (typeof f == "string" || typeof f == "function" || f === A || f === C || f === D || f === St || f === _t || f === ts || typeof f == "object" && f !== null && (f.$$typeof === he || f.$$typeof === At || f.$$typeof === _ || f.$$typeof === I || f.$$typeof === tt || f.$$typeof === mo || f.getModuleId !== void 0)) {
        var E = b.children;
        if (E !== void 0)
          if (R)
            if (Le(E)) {
              for (R = 0; R < E.length; R++)
                y(E[R], f);
              Object.freeze && Object.freeze(E);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else y(E, f);
      } else
        E = "", (f === void 0 || typeof f == "object" && f !== null && Object.keys(f).length === 0) && (E += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), f === null ? R = "null" : Le(f) ? R = "array" : f !== void 0 && f.$$typeof === M ? (R = "<" + (t(f.type) || "Unknown") + " />", E = " Did you accidentally export a JSX literal instead of a component?") : R = typeof f, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          R,
          E
        );
      if (Ct.call(b, "key")) {
        E = t(f);
        var it = Object.keys(b).filter(function(K) {
          return K !== "key";
        });
        R = 0 < it.length ? "{key: someKey, " + it.join(": ..., ") + ": ...}" : "{key: someKey}", hs[E + R] || (it = 0 < it.length ? "{" + it.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          R,
          E,
          it,
          E
        ), hs[E + R] = !0);
      }
      if (E = null, w !== void 0 && (n(w), E = "" + w), u(b) && (n(b.key), E = "" + b.key), "key" in b) {
        w = {};
        for (var Et in b)
          Et !== "key" && (w[Et] = b[Et]);
      } else w = b;
      return E && h(
        w,
        typeof f == "function" ? f.displayName || f.name || "Unknown" : f
      ), m(f, E, k, $, c(), w);
    }
    function y(f, b) {
      if (typeof f == "object" && f && f.$$typeof !== po) {
        if (Le(f))
          for (var w = 0; w < f.length; w++) {
            var R = f[w];
            v(R) && g(R, b);
          }
        else if (v(f))
          f._store && (f._store.validated = 1);
        else if (f === null || typeof f != "object" ? w = null : (w = N && f[N] || f["@@iterator"], w = typeof w == "function" ? w : null), typeof w == "function" && w !== f.entries && (w = w.call(f), w !== f))
          for (; !(f = w.next()).done; )
            v(f.value) && g(f.value, b);
      }
    }
    function v(f) {
      return typeof f == "object" && f !== null && f.$$typeof === M;
    }
    function g(f, b) {
      if (f._store && !f._store.validated && f.key == null && (f._store.validated = 1, b = T(b), !fs[b])) {
        fs[b] = !0;
        var w = "";
        f && f._owner != null && f._owner !== c() && (w = null, typeof f._owner.tag == "number" ? w = t(f._owner.type) : typeof f._owner.name == "string" && (w = f._owner.name), w = " It was passed a child from " + w + ".");
        var R = J.getCurrentStack;
        J.getCurrentStack = function() {
          var $ = l(f.type);
          return R && ($ += R() || ""), $;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          b,
          w
        ), J.getCurrentStack = R;
      }
    }
    function T(f) {
      var b = "", w = c();
      return w && (w = t(w.type)) && (b = `

Check the render method of \`` + w + "`."), b || (f = t(f)) && (b = `

Check the top-level render call using <` + f + ">."), b;
    }
    var P = go, M = Symbol.for("react.transitional.element"), x = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), D = Symbol.for("react.strict_mode"), C = Symbol.for("react.profiler"), I = Symbol.for("react.consumer"), _ = Symbol.for("react.context"), tt = Symbol.for("react.forward_ref"), St = Symbol.for("react.suspense"), _t = Symbol.for("react.suspense_list"), At = Symbol.for("react.memo"), he = Symbol.for("react.lazy"), ts = Symbol.for("react.offscreen"), N = Symbol.iterator, Z = Symbol.for("react.client.reference"), J = P.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ct = Object.prototype.hasOwnProperty, pt = Object.assign, mo = Symbol.for("react.client.reference"), Le = Array.isArray, Ut = 0, es, ns, ss, is, rs, os, as;
    s.__reactDisabledLog = !0;
    var ke, ls, je = !1, Be = new (typeof WeakMap == "function" ? WeakMap : Map)(), po = Symbol.for("react.client.reference"), cs, us = {}, hs = {}, fs = {};
    Wt.Fragment = A, Wt.jsx = function(f, b, w, R, $) {
      return p(f, b, w, !1, R, $);
    }, Wt.jsxs = function(f, b, w, R, $) {
      return p(f, b, w, !0, R, $);
    };
  }()), Wt;
}
var ps;
function Ao() {
  return ps || (ps = 1, process.env.NODE_ENV === "production" ? de.exports = Po() : de.exports = So()), de.exports;
}
var V = Ao();
const Co = "_NavBarContainer_e4224_1", Eo = "_AppTitle_e4224_9", Vo = "_NavBarActions_e4224_16", Mo = "_IconButton_e4224_22", Ht = {
  NavBarContainer: Co,
  AppTitle: Eo,
  NavBarActions: Vo,
  IconButton: Mo
}, Ro = () => /* @__PURE__ */ V.jsx(
  "svg",
  {
    width: "31",
    height: "31",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ V.jsx("g", { children: /* @__PURE__ */ V.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.73877 7.82818C6.73877 7.27326 6.95921 6.74106 7.3516 6.34867C7.74399 5.95628 8.27619 5.73584 8.83111 5.73584H18.5954C19.1503 5.73584 19.6825 5.95628 20.0749 6.34867C20.4673 6.74106 20.6877 7.27326 20.6877 7.82818V10.5329C20.1217 10.9862 19.7545 11.6421 19.6639 12.3616H14.7594C14.3473 12.3616 13.9391 12.4428 13.5584 12.6005C13.1776 12.7582 12.8316 12.9894 12.5402 13.2808C12.2487 13.5723 12.0175 13.9183 11.8598 14.299C11.7021 14.6798 11.6209 15.0879 11.6209 15.5001C11.6209 15.9123 11.7021 16.3204 11.8598 16.7012C12.0175 17.0819 12.2487 17.4279 12.5402 17.7194C12.8316 18.0108 13.1776 18.242 13.5584 18.3997C13.9391 18.5574 14.3473 18.6386 14.7594 18.6386H19.6639C19.7545 19.3581 20.1217 20.014 20.6877 20.4673V23.172C20.6877 23.7269 20.4673 24.2591 20.0749 24.6515C19.6825 25.0439 19.1503 25.2644 18.5954 25.2644H8.83111C8.27619 25.2644 7.74399 25.0439 7.3516 24.6515C6.95921 24.2591 6.73877 23.7269 6.73877 23.172V7.82818ZM22.031 11.7437C21.8398 11.8228 21.6764 11.9569 21.5614 12.129C21.4465 12.3011 21.3851 12.5034 21.3852 12.7103V14.1052H14.7594C14.3895 14.1052 14.0347 14.2522 13.7731 14.5138C13.5115 14.7754 13.3645 15.1302 13.3645 15.5001C13.3645 15.8701 13.5115 16.2248 13.7731 16.4864C14.0347 16.748 14.3895 16.895 14.7594 16.895H21.3852V18.2899C21.3853 18.4967 21.4468 18.6988 21.5618 18.8706C21.6767 19.0425 21.8401 19.1765 22.0311 19.2556C22.2222 19.3347 22.4324 19.3554 22.6352 19.3151C22.838 19.2748 23.0243 19.1753 23.1706 19.0292L25.9604 16.2394C26.1563 16.0432 26.2664 15.7773 26.2664 15.5001C26.2664 15.2229 26.1563 14.957 25.9604 14.7608L23.1706 11.971C23.0244 11.8247 22.8381 11.725 22.6353 11.6845C22.4324 11.6441 22.2222 11.6646 22.031 11.7437Z",
        fill: "currentColor"
      }
    ) })
  }
), Tn = Ot({});
function bn(t) {
  const e = ut(null);
  return e.current === null && (e.current = t()), e.current;
}
const wn = typeof window < "u", Ii = wn ? yo : yn, Ce = /* @__PURE__ */ Ot(null), Pn = Ot({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
class Do extends O.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const s = n.offsetParent, i = s instanceof HTMLElement && s.offsetWidth || 0, o = this.props.sizeRef.current;
      o.height = n.offsetHeight || 0, o.width = n.offsetWidth || 0, o.top = n.offsetTop, o.left = n.offsetLeft, o.right = i - o.width - o.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Lo({ children: t, isPresent: e, anchorX: n }) {
  const s = vn(), i = ut(null), o = ut({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: r } = W(Pn);
  return Oi(() => {
    const { width: a, height: l, top: c, left: u, right: h } = o.current;
    if (e || !i.current || !a || !l)
      return;
    const d = n === "left" ? `left: ${u}` : `right: ${h}`;
    i.current.dataset.motionPopId = s;
    const m = document.createElement("style");
    return r && (m.nonce = r), document.head.appendChild(m), m.sheet && m.sheet.insertRule(`
          [data-motion-pop-id="${s}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${l}px !important;
            ${d}px !important;
            top: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(m);
    };
  }, [e]), V.jsx(Do, { isPresent: e, childRef: i, sizeRef: o, children: O.cloneElement(t, { ref: i }) });
}
const ko = ({ children: t, initial: e, isPresent: n, onExitComplete: s, custom: i, presenceAffectsLayout: o, mode: r, anchorX: a }) => {
  const l = bn(jo), c = vn(), u = xn((d) => {
    l.set(d, !0);
    for (const m of l.values())
      if (!m)
        return;
    s && s();
  }, [l, s]), h = wt(
    () => ({
      id: c,
      initial: e,
      isPresent: n,
      custom: i,
      onExitComplete: u,
      register: (d) => (l.set(d, !1), () => l.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    o ? [Math.random(), u] : [n, u]
  );
  return wt(() => {
    l.forEach((d, m) => l.set(m, !1));
  }, [n]), O.useEffect(() => {
    !n && !l.size && s && s();
  }, [n]), r === "popLayout" && (t = V.jsx(Lo, { isPresent: n, anchorX: a, children: t })), V.jsx(Ce.Provider, { value: h, children: t });
};
function jo() {
  return /* @__PURE__ */ new Map();
}
function Ni(t = !0) {
  const e = W(Ce);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: s, register: i } = e, o = vn();
  yn(() => {
    if (t)
      return i(o);
  }, [t]);
  const r = xn(() => t && s && s(o), [o, s, t]);
  return !n && s ? [!1, r] : [!0];
}
const me = (t) => t.key || "";
function gs(t) {
  const e = [];
  return vo.forEach(t, (n) => {
    xo(n) && e.push(n);
  }), e;
}
const Bo = ({ children: t, custom: e, initial: n = !0, onExitComplete: s, presenceAffectsLayout: i = !0, mode: o = "sync", propagate: r = !1, anchorX: a = "left" }) => {
  const [l, c] = Ni(r), u = wt(() => gs(t), [t]), h = r && !l ? [] : u.map(me), d = ut(!0), m = ut(u), p = bn(() => /* @__PURE__ */ new Map()), [y, v] = qe(u), [g, T] = qe(u);
  Ii(() => {
    d.current = !1, m.current = u;
    for (let x = 0; x < g.length; x++) {
      const A = me(g[x]);
      h.includes(A) ? p.delete(A) : p.get(A) !== !0 && p.set(A, !1);
    }
  }, [g, h.length, h.join("-")]);
  const P = [];
  if (u !== y) {
    let x = [...u];
    for (let A = 0; A < g.length; A++) {
      const D = g[A], C = me(D);
      h.includes(C) || (x.splice(A, 0, D), P.push(D));
    }
    return o === "wait" && P.length && (x = P), T(gs(x)), v(u), null;
  }
  process.env.NODE_ENV !== "production" && o === "wait" && g.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: M } = W(Tn);
  return V.jsx(V.Fragment, { children: g.map((x) => {
    const A = me(x), D = r && !l ? !1 : u === g || h.includes(A), C = () => {
      if (p.has(A))
        p.set(A, !0);
      else
        return;
      let I = !0;
      p.forEach((_) => {
        _ || (I = !1);
      }), I && (M?.(), T(m.current), r && c?.(), s && s());
    };
    return V.jsx(ko, { isPresent: D, initial: !d.current || n ? void 0 : !1, custom: e, presenceAffectsLayout: i, mode: o, onExitComplete: D ? void 0 : C, anchorX: a, children: x }, A);
  }) });
}, G = /* @__NO_SIDE_EFFECTS__ */ (t) => t;
let Ft = G, ht = G;
process.env.NODE_ENV !== "production" && (Ft = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, ht = (t, e) => {
  if (!t)
    throw new Error(e);
});
const Oo = {
  useManualTiming: !1
}, pe = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], ys = {
  value: null
};
function Fo(t, e) {
  let n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), i = !1, o = !1;
  const r = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, l = 0;
  function c(h) {
    r.has(h) && (u.schedule(h), t()), l++, h(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (h, d = !1, m = !1) => {
      const y = m && i ? n : s;
      return d && r.add(h), y.has(h) || y.add(h), h;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (h) => {
      s.delete(h), r.delete(h);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (h) => {
      if (a = h, i) {
        o = !0;
        return;
      }
      i = !0, [n, s] = [s, n], n.forEach(c), e && ys.value && ys.value.frameloop[e].push(l), l = 0, n.clear(), i = !1, o && (o = !1, u.process(h));
    }
  };
  return u;
}
const Io = 40;
function _i(t, e) {
  let n = !1, s = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, r = pe.reduce((g, T) => (g[T] = Fo(o, e ? T : void 0), g), {}), { read: a, resolveKeyframes: l, update: c, preRender: u, render: h, postRender: d } = r, m = () => {
    const g = performance.now();
    n = !1, i.delta = s ? 1e3 / 60 : Math.max(Math.min(g - i.timestamp, Io), 1), i.timestamp = g, i.isProcessing = !0, a.process(i), l.process(i), c.process(i), u.process(i), h.process(i), d.process(i), i.isProcessing = !1, n && e && (s = !1, t(m));
  }, p = () => {
    n = !0, s = !0, i.isProcessing || t(m);
  };
  return { schedule: pe.reduce((g, T) => {
    const P = r[T];
    return g[T] = (M, x = !1, A = !1) => (n || p(), P.schedule(M, x, A)), g;
  }, {}), cancel: (g) => {
    for (let T = 0; T < pe.length; T++)
      r[pe[T]].cancel(g);
  }, state: i, steps: r };
}
const { schedule: L, cancel: ft, state: U, steps: Oe } = /* @__PURE__ */ _i(typeof requestAnimationFrame < "u" ? requestAnimationFrame : G, !0), Ui = Ot({ strict: !1 }), vs = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, kt = {};
for (const t in vs)
  kt[t] = {
    isEnabled: (e) => vs[t].some((n) => !!e[n])
  };
function No(t) {
  for (const e in t)
    kt[e] = {
      ...kt[e],
      ...t[e]
    };
}
const _o = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function be(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || _o.has(t);
}
let $i = (t) => !be(t);
function Uo(t) {
  t && ($i = (e) => e.startsWith("on") ? !be(e) : t(e));
}
try {
  Uo(require("@emotion/is-prop-valid").default);
} catch {
}
function $o(t, e, n) {
  const s = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || ($i(i) || n === !0 && be(i) || !e && !be(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (s[i] = t[i]);
  return s;
}
const xs = /* @__PURE__ */ new Set();
function Ee(t, e, n) {
  t || xs.has(e) || (console.warn(e), xs.add(e));
}
function zo(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), n = (...s) => (process.env.NODE_ENV !== "production" && Ee(!1, "motion() is deprecated. Use motion.create() instead."), t(...s));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (s, i) => i === "create" ? t : (e.has(i) || e.set(i, t(i)), e.get(i))
  });
}
const Ve = /* @__PURE__ */ Ot({});
function Me(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function te(t) {
  return typeof t == "string" || Array.isArray(t);
}
const Sn = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], An = ["initial", ...Sn];
function Re(t) {
  return Me(t.animate) || An.some((e) => te(t[e]));
}
function zi(t) {
  return !!(Re(t) || t.variants);
}
function Wo(t, e) {
  if (Re(t)) {
    const { initial: n, animate: s } = t;
    return {
      initial: n === !1 || te(n) ? n : void 0,
      animate: te(s) ? s : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function Ho(t) {
  const { initial: e, animate: n } = Wo(t, W(Ve));
  return wt(() => ({ initial: e, animate: n }), [Ts(e), Ts(n)]);
}
function Ts(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Ko = Symbol.for("motionComponentSymbol");
function Vt(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Yo(t, e, n) {
  return xn(
    (s) => {
      s && t.onMount && t.onMount(s), e && (s ? e.mount(s) : e.unmount()), n && (typeof n == "function" ? n(s) : Vt(n) && (n.current = s));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const { schedule: Cn } = /* @__PURE__ */ _i(queueMicrotask, !1), En = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Go = "framerAppearId", Wi = "data-" + En(Go), Hi = Ot({});
function Xo(t, e, n, s, i) {
  var o, r;
  const { visualElement: a } = W(Ve), l = W(Ui), c = W(Ce), u = W(Pn).reducedMotion, h = ut(null);
  s = s || l.renderer, !h.current && s && (h.current = s(t, {
    visualState: e,
    parent: a,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const d = h.current, m = W(Hi);
  d && !d.projection && i && (d.type === "html" || d.type === "svg") && qo(h.current, n, i, m);
  const p = ut(!1);
  Oi(() => {
    d && p.current && d.update(n, c);
  });
  const y = n[Wi], v = ut(!!y && !(!((o = window.MotionHandoffIsComplete) === null || o === void 0) && o.call(window, y)) && ((r = window.MotionHasOptimisedAnimation) === null || r === void 0 ? void 0 : r.call(window, y)));
  return Ii(() => {
    d && (p.current = !0, window.MotionIsMounted = !0, d.updateFeatures(), Cn.render(d.render), v.current && d.animationState && d.animationState.animateChanges());
  }), yn(() => {
    d && (!v.current && d.animationState && d.animationState.animateChanges(), v.current && (queueMicrotask(() => {
      var g;
      (g = window.MotionHandoffMarkAsComplete) === null || g === void 0 || g.call(window, y);
    }), v.current = !1));
  }), d;
}
function qo(t, e, n, s) {
  const { layoutId: i, layout: o, drag: r, dragConstraints: a, layoutScroll: l, layoutRoot: c } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : Ki(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!r || a && Vt(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: s,
    layoutScroll: l,
    layoutRoot: c
  });
}
function Ki(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : Ki(t.parent);
}
function Zo({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: s, Component: i }) {
  var o, r;
  t && No(t);
  function a(c, u) {
    let h;
    const d = {
      ...W(Pn),
      ...c,
      layoutId: Jo(c)
    }, { isStatic: m } = d, p = Ho(c), y = s(c, m);
    if (!m && wn) {
      Qo(d, t);
      const v = ta(d);
      h = v.MeasureLayout, p.visualElement = Xo(i, y, d, e, v.ProjectionNode);
    }
    return V.jsxs(Ve.Provider, { value: p, children: [h && p.visualElement ? V.jsx(h, { visualElement: p.visualElement, ...d }) : null, n(i, c, Yo(y, p.visualElement, u), y, m, p.visualElement)] });
  }
  a.displayName = `motion.${typeof i == "string" ? i : `create(${(r = (o = i.displayName) !== null && o !== void 0 ? o : i.name) !== null && r !== void 0 ? r : ""})`}`;
  const l = To(a);
  return l[Ko] = i, l;
}
function Jo({ layoutId: t }) {
  const e = W(Tn).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function Qo(t, e) {
  const n = W(Ui).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const s = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? Ft(!1, s) : ht(!1, s);
  }
}
function ta(t) {
  const { drag: e, layout: n } = kt;
  if (!e && !n)
    return {};
  const s = { ...e, ...n };
  return {
    MeasureLayout: e?.isEnabled(t) || n?.isEnabled(t) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
const Yi = (t) => (e) => typeof e == "string" && e.startsWith(t), Vn = /* @__PURE__ */ Yi("--"), ea = /* @__PURE__ */ Yi("var(--"), Mn = (t) => ea(t) ? na.test(t.split("/*")[0].trim()) : !1, na = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, ee = {};
function sa(t) {
  for (const e in t)
    ee[e] = t[e], Vn(e) && (ee[e].isCSSVariable = !0);
}
const It = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Pt = new Set(It);
function Gi(t, { layout: e, layoutId: n }) {
  return Pt.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!ee[t] || t === "opacity");
}
const H = (t) => !!(t && t.getVelocity), Xi = (t, e) => e && typeof t == "number" ? e.transform(t) : t, at = (t, e, n) => n > e ? e : n < t ? t : n, Nt = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, ne = {
  ...Nt,
  transform: (t) => at(0, 1, t)
}, ge = {
  ...Nt,
  default: 1
}, ae = (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), ct = /* @__PURE__ */ ae("deg"), et = /* @__PURE__ */ ae("%"), S = /* @__PURE__ */ ae("px"), ia = /* @__PURE__ */ ae("vh"), ra = /* @__PURE__ */ ae("vw"), bs = {
  ...et,
  parse: (t) => et.parse(t) / 100,
  transform: (t) => et.transform(t * 100)
}, oa = {
  // Border props
  borderWidth: S,
  borderTopWidth: S,
  borderRightWidth: S,
  borderBottomWidth: S,
  borderLeftWidth: S,
  borderRadius: S,
  radius: S,
  borderTopLeftRadius: S,
  borderTopRightRadius: S,
  borderBottomRightRadius: S,
  borderBottomLeftRadius: S,
  // Positioning props
  width: S,
  maxWidth: S,
  height: S,
  maxHeight: S,
  top: S,
  right: S,
  bottom: S,
  left: S,
  // Spacing props
  padding: S,
  paddingTop: S,
  paddingRight: S,
  paddingBottom: S,
  paddingLeft: S,
  margin: S,
  marginTop: S,
  marginRight: S,
  marginBottom: S,
  marginLeft: S,
  // Misc
  backgroundPositionX: S,
  backgroundPositionY: S
}, aa = {
  rotate: ct,
  rotateX: ct,
  rotateY: ct,
  rotateZ: ct,
  scale: ge,
  scaleX: ge,
  scaleY: ge,
  scaleZ: ge,
  skew: ct,
  skewX: ct,
  skewY: ct,
  distance: S,
  translateX: S,
  translateY: S,
  translateZ: S,
  x: S,
  y: S,
  z: S,
  perspective: S,
  transformPerspective: S,
  opacity: ne,
  originX: bs,
  originY: bs,
  originZ: S
}, ws = {
  ...Nt,
  transform: Math.round
}, Rn = {
  ...oa,
  ...aa,
  zIndex: ws,
  size: S,
  // SVG
  fillOpacity: ne,
  strokeOpacity: ne,
  numOctaves: ws
}, la = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, ca = It.length;
function ua(t, e, n) {
  let s = "", i = !0;
  for (let o = 0; o < ca; o++) {
    const r = It[o], a = t[r];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (r.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const c = Xi(a, Rn[r]);
      if (!l) {
        i = !1;
        const u = la[r] || r;
        s += `${u}(${c}) `;
      }
      n && (e[r] = c);
    }
  }
  return s = s.trim(), n ? s = n(e, i ? "" : s) : i && (s = "none"), s;
}
function Dn(t, e, n) {
  const { style: s, vars: i, transformOrigin: o } = t;
  let r = !1, a = !1;
  for (const l in e) {
    const c = e[l];
    if (Pt.has(l)) {
      r = !0;
      continue;
    } else if (Vn(l)) {
      i[l] = c;
      continue;
    } else {
      const u = Xi(c, Rn[l]);
      l.startsWith("origin") ? (a = !0, o[l] = u) : s[l] = u;
    }
  }
  if (e.transform || (r || n ? s.transform = ua(e, t.transform, n) : s.transform && (s.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = o;
    s.transformOrigin = `${l} ${c} ${u}`;
  }
}
const Ln = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function qi(t, e, n) {
  for (const s in e)
    !H(e[s]) && !Gi(s, n) && (t[s] = e[s]);
}
function ha({ transformTemplate: t }, e) {
  return wt(() => {
    const n = Ln();
    return Dn(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function fa(t, e) {
  const n = t.style || {}, s = {};
  return qi(s, n, t), Object.assign(s, ha(t, e)), s;
}
function da(t, e) {
  const n = {}, s = fa(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, s.userSelect = s.WebkitUserSelect = s.WebkitTouchCallout = "none", s.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = s, n;
}
const ma = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function kn(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(ma.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
const pa = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, ga = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function ya(t, e, n = 1, s = 0, i = !0) {
  t.pathLength = 1;
  const o = i ? pa : ga;
  t[o.offset] = S.transform(-s);
  const r = S.transform(e), a = S.transform(n);
  t[o.array] = `${r} ${a}`;
}
function Ps(t, e, n) {
  return typeof t == "string" ? t : S.transform(e + n * t);
}
function va(t, e, n) {
  const s = Ps(e, t.x, t.width), i = Ps(n, t.y, t.height);
  return `${s} ${i}`;
}
function jn(t, {
  attrX: e,
  attrY: n,
  attrScale: s,
  originX: i,
  originY: o,
  pathLength: r,
  pathSpacing: a = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, h) {
  if (Dn(t, c, h), u) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: d, style: m, dimensions: p } = t;
  d.transform && (p && (m.transform = d.transform), delete d.transform), p && (i !== void 0 || o !== void 0 || m.transform) && (m.transformOrigin = va(p, i !== void 0 ? i : 0.5, o !== void 0 ? o : 0.5)), e !== void 0 && (d.x = e), n !== void 0 && (d.y = n), s !== void 0 && (d.scale = s), r !== void 0 && ya(d, r, a, l, !1);
}
const Zi = () => ({
  ...Ln(),
  attrs: {}
}), Bn = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function xa(t, e, n, s) {
  const i = wt(() => {
    const o = Zi();
    return jn(o, e, Bn(s), t.transformTemplate), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [e]);
  if (t.style) {
    const o = {};
    qi(o, t.style, t), i.style = { ...o, ...i.style };
  }
  return i;
}
function Ta(t = !1) {
  return (n, s, i, { latestValues: o }, r) => {
    const l = (kn(n) ? xa : da)(s, o, r, n), c = $o(s, typeof n == "string", t), u = n !== Fi ? { ...c, ...l, ref: i } : {}, { children: h } = s, d = wt(() => H(h) ? h.get() : h, [h]);
    return bo(n, {
      ...u,
      children: d
    });
  };
}
function Ss(t) {
  const e = [{}, {}];
  return t?.values.forEach((n, s) => {
    e[0][s] = n.get(), e[1][s] = n.getVelocity();
  }), e;
}
function On(t, e, n, s) {
  if (typeof e == "function") {
    const [i, o] = Ss(s);
    e = e(n !== void 0 ? n : t.custom, i, o);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, o] = Ss(s);
    e = e(n !== void 0 ? n : t.custom, i, o);
  }
  return e;
}
const Ze = (t) => Array.isArray(t), ba = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), wa = (t) => Ze(t) ? t[t.length - 1] || 0 : t;
function ve(t) {
  const e = H(t) ? t.get() : t;
  return ba(e) ? e.toValue() : e;
}
function Pa({ scrapeMotionValuesFromProps: t, createRenderState: e, onUpdate: n }, s, i, o) {
  const r = {
    latestValues: Sa(s, i, o, t),
    renderState: e()
  };
  return n && (r.onMount = (a) => n({ props: s, current: a, ...r }), r.onUpdate = (a) => n(a)), r;
}
const Ji = (t) => (e, n) => {
  const s = W(Ve), i = W(Ce), o = () => Pa(t, e, s, i);
  return n ? o() : bn(o);
};
function Sa(t, e, n, s) {
  const i = {}, o = s(t, {});
  for (const d in o)
    i[d] = ve(o[d]);
  let { initial: r, animate: a } = t;
  const l = Re(t), c = zi(t);
  e && c && !l && t.inherit !== !1 && (r === void 0 && (r = e.initial), a === void 0 && (a = e.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || r === !1;
  const h = u ? a : r;
  if (h && typeof h != "boolean" && !Me(h)) {
    const d = Array.isArray(h) ? h : [h];
    for (let m = 0; m < d.length; m++) {
      const p = On(t, d[m]);
      if (p) {
        const { transitionEnd: y, transition: v, ...g } = p;
        for (const T in g) {
          let P = g[T];
          if (Array.isArray(P)) {
            const M = u ? P.length - 1 : 0;
            P = P[M];
          }
          P !== null && (i[T] = P);
        }
        for (const T in y)
          i[T] = y[T];
      }
    }
  }
  return i;
}
function Fn(t, e, n) {
  var s;
  const { style: i } = t, o = {};
  for (const r in i)
    (H(i[r]) || e.style && H(e.style[r]) || Gi(r, t) || ((s = n?.getValue(r)) === null || s === void 0 ? void 0 : s.liveStyle) !== void 0) && (o[r] = i[r]);
  return o;
}
const Aa = {
  useVisualState: Ji({
    scrapeMotionValuesFromProps: Fn,
    createRenderState: Ln
  })
};
function Qi(t, e) {
  try {
    e.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
  } catch {
    e.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
function tr(t, { style: e, vars: n }, s, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(s));
  for (const o in n)
    t.style.setProperty(o, n[o]);
}
const er = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function nr(t, e, n, s) {
  tr(t, e, void 0, s);
  for (const i in e.attrs)
    t.setAttribute(er.has(i) ? i : En(i), e.attrs[i]);
}
function sr(t, e, n) {
  const s = Fn(t, e, n);
  for (const i in t)
    if (H(t[i]) || H(e[i])) {
      const o = It.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      s[o] = t[i];
    }
  return s;
}
const As = ["x", "y", "width", "height", "cx", "cy", "r"], Ca = {
  useVisualState: Ji({
    scrapeMotionValuesFromProps: sr,
    createRenderState: Zi,
    onUpdate: ({ props: t, prevProps: e, current: n, renderState: s, latestValues: i }) => {
      if (!n)
        return;
      let o = !!t.drag;
      if (!o) {
        for (const a in i)
          if (Pt.has(a)) {
            o = !0;
            break;
          }
      }
      if (!o)
        return;
      let r = !e;
      if (e)
        for (let a = 0; a < As.length; a++) {
          const l = As[a];
          t[l] !== e[l] && (r = !0);
        }
      r && L.read(() => {
        Qi(n, s), L.render(() => {
          jn(s, i, Bn(n.tagName), t.transformTemplate), nr(n, s);
        });
      });
    }
  })
};
function Ea(t, e) {
  return function(s, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const r = {
      ...kn(s) ? Ca : Aa,
      preloadedFeatures: t,
      useRender: Ta(i),
      createVisualElement: e,
      Component: s
    };
    return Zo(r);
  };
}
function se(t, e, n) {
  const s = t.getProps();
  return On(s, e, n !== void 0 ? n : s.custom, t);
}
function In(t, e) {
  return t ? t[e] || t.default || t : void 0;
}
const ir = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...It
]);
function Nn(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function _n(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class Un {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Nn(this.subscriptions, e), () => _n(this.subscriptions, e);
  }
  notify(e, n, s) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let o = 0; o < i; o++) {
          const r = this.subscriptions[o];
          r && r(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function rr(t, e) {
  return e ? t * (1e3 / e) : 0;
}
let xe;
function Va() {
  xe = void 0;
}
const nt = {
  now: () => (xe === void 0 && nt.set(U.isProcessing || Oo.useManualTiming ? U.timestamp : performance.now()), xe),
  set: (t) => {
    xe = t, queueMicrotask(Va);
  }
}, Cs = 30, Ma = (t) => !isNaN(parseFloat(t));
class Ra {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.version = "12.6.1", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (s, i = !0) => {
      const o = nt.now();
      this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = nt.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Ma(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Ee(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Un());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), L.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = nt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Cs)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Cs);
    return rr(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ie(t, e) {
  return new Ra(t, e);
}
function Da(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, ie(n));
}
function La(t, e) {
  const n = se(t, e);
  let { transitionEnd: s = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...s };
  for (const r in o) {
    const a = wa(o[r]);
    Da(t, r, a);
  }
}
function ka(t) {
  return !!(H(t) && t.add);
}
function Je(t, e) {
  const n = t.getValue("willChange");
  if (ka(n))
    return n.add(e);
}
function or(t) {
  return t.props[Wi];
}
// @__NO_SIDE_EFFECTS__
function $n(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const ja = /* @__PURE__ */ $n(() => window.ScrollTimeline !== void 0);
class Ba {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => "finished" in e ? e.finished : e));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let s = 0; s < this.animations.length; s++)
      this.animations[s][e] = n;
  }
  attachTimeline(e, n) {
    const s = this.animations.map((i) => {
      if (ja() && i.attachTimeline)
        return i.attachTimeline(e);
      if (typeof n == "function")
        return n(i);
    });
    return () => {
      s.forEach((i, o) => {
        i && i(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class Oa extends Ba {
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
}
const st = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, ot = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function zn(t) {
  return typeof t == "function";
}
function Es(t, e) {
  t.timeline = e, t.onfinish = null;
}
const Wn = (t) => Array.isArray(t) && typeof t[0] == "number", Fa = {
  linearEasing: void 0
};
function Ia(t, e) {
  const n = /* @__PURE__ */ $n(t);
  return () => {
    var s;
    return (s = Fa[e]) !== null && s !== void 0 ? s : n();
  };
}
const we = /* @__PURE__ */ Ia(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), jt = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
}, ar = (t, e, n = 10) => {
  let s = "";
  const i = Math.max(Math.round(e / n), 2);
  for (let o = 0; o < i; o++)
    s += t(/* @__PURE__ */ jt(0, i - 1, o)) + ", ";
  return `linear(${s.substring(0, s.length - 2)})`;
};
function lr(t) {
  return !!(typeof t == "function" && we() || !t || typeof t == "string" && (t in Qe || we()) || Wn(t) || Array.isArray(t) && t.every(lr));
}
const Yt = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, Qe = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Yt([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Yt([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Yt([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Yt([0.33, 1.53, 0.69, 0.99])
};
function cr(t, e) {
  if (t)
    return typeof t == "function" && we() ? ar(t, e) : Wn(t) ? Yt(t) : Array.isArray(t) ? t.map((n) => cr(n, e) || Qe.easeOut) : Qe[t];
}
const ur = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, Na = 1e-7, _a = 12;
function Ua(t, e, n, s, i) {
  let o, r, a = 0;
  do
    r = e + (n - e) / 2, o = ur(r, s, i) - t, o > 0 ? n = r : e = r;
  while (Math.abs(o) > Na && ++a < _a);
  return r;
}
function le(t, e, n, s) {
  if (t === e && n === s)
    return G;
  const i = (o) => Ua(o, 0, 1, t, n);
  return (o) => o === 0 || o === 1 ? o : ur(i(o), e, s);
}
const hr = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, fr = (t) => (e) => 1 - t(1 - e), dr = /* @__PURE__ */ le(0.33, 1.53, 0.69, 0.99), Hn = /* @__PURE__ */ fr(dr), mr = /* @__PURE__ */ hr(Hn), pr = (t) => (t *= 2) < 1 ? 0.5 * Hn(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Kn = (t) => 1 - Math.sin(Math.acos(t)), gr = fr(Kn), yr = hr(Kn), vr = (t) => /^0[^.\s]+$/u.test(t);
function $a(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || vr(t) : !0;
}
const Xt = (t) => Math.round(t * 1e5) / 1e5, Yn = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function za(t) {
  return t == null;
}
const Wa = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Gn = (t, e) => (n) => !!(typeof n == "string" && Wa.test(n) && n.startsWith(t) || e && !za(n) && Object.prototype.hasOwnProperty.call(n, e)), xr = (t, e, n) => (s) => {
  if (typeof s != "string")
    return s;
  const [i, o, r, a] = s.match(Yn);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(o),
    [n]: parseFloat(r),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Ha = (t) => at(0, 255, t), Fe = {
  ...Nt,
  transform: (t) => Math.round(Ha(t))
}, xt = {
  test: /* @__PURE__ */ Gn("rgb", "red"),
  parse: /* @__PURE__ */ xr("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + Fe.transform(t) + ", " + Fe.transform(e) + ", " + Fe.transform(n) + ", " + Xt(ne.transform(s)) + ")"
};
function Ka(t) {
  let e = "", n = "", s = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, s += s, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const tn = {
  test: /* @__PURE__ */ Gn("#"),
  parse: Ka,
  transform: xt.transform
}, Mt = {
  test: /* @__PURE__ */ Gn("hsl", "hue"),
  parse: /* @__PURE__ */ xr("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + et.transform(Xt(e)) + ", " + et.transform(Xt(n)) + ", " + Xt(ne.transform(s)) + ")"
}, z = {
  test: (t) => xt.test(t) || tn.test(t) || Mt.test(t),
  parse: (t) => xt.test(t) ? xt.parse(t) : Mt.test(t) ? Mt.parse(t) : tn.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? xt.transform(t) : Mt.transform(t)
}, Ya = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Ga(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(Yn)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(Ya)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const Tr = "number", br = "color", Xa = "var", qa = "var(", Vs = "${}", Za = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function re(t) {
  const e = t.toString(), n = [], s = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const a = e.replace(Za, (l) => (z.test(l) ? (s.color.push(o), i.push(br), n.push(z.parse(l))) : l.startsWith(qa) ? (s.var.push(o), i.push(Xa), n.push(l)) : (s.number.push(o), i.push(Tr), n.push(parseFloat(l))), ++o, Vs)).split(Vs);
  return { values: n, split: a, indexes: s, types: i };
}
function wr(t) {
  return re(t).values;
}
function Pr(t) {
  const { split: e, types: n } = re(t), s = e.length;
  return (i) => {
    let o = "";
    for (let r = 0; r < s; r++)
      if (o += e[r], i[r] !== void 0) {
        const a = n[r];
        a === Tr ? o += Xt(i[r]) : a === br ? o += z.transform(i[r]) : o += i[r];
      }
    return o;
  };
}
const Ja = (t) => typeof t == "number" ? 0 : t;
function Qa(t) {
  const e = wr(t);
  return Pr(t)(e.map(Ja));
}
const dt = {
  test: Ga,
  parse: wr,
  createTransformer: Pr,
  getAnimatableNone: Qa
}, tl = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function el(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [s] = n.match(Yn) || [];
  if (!s)
    return t;
  const i = n.replace(s, "");
  let o = tl.has(e) ? 1 : 0;
  return s !== n && (o *= 100), e + "(" + o + i + ")";
}
const nl = /\b([a-z-]*)\(.*?\)/gu, en = {
  ...dt,
  getAnimatableNone: (t) => {
    const e = t.match(nl);
    return e ? e.map(el).join(" ") : t;
  }
}, sl = {
  ...Rn,
  // Color props
  color: z,
  backgroundColor: z,
  outlineColor: z,
  fill: z,
  stroke: z,
  // Border props
  borderColor: z,
  borderTopColor: z,
  borderRightColor: z,
  borderBottomColor: z,
  borderLeftColor: z,
  filter: en,
  WebkitFilter: en
}, Sr = (t) => sl[t];
function Ar(t, e) {
  let n = Sr(t);
  return n !== en && (n = dt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const il = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function rl(t, e, n) {
  let s = 0, i;
  for (; s < t.length && !i; ) {
    const o = t[s];
    typeof o == "string" && !il.has(o) && re(o).values.length && (i = t[s]), s++;
  }
  if (i && n)
    for (const o of e)
      t[o] = Ar(n, i);
}
const Tt = (t) => t * 180 / Math.PI, nn = (t) => {
  const e = Tt(Math.atan2(t[1], t[0]));
  return sn(e);
}, ol = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: nn,
  rotateZ: nn,
  skewX: (t) => Tt(Math.atan(t[1])),
  skewY: (t) => Tt(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, sn = (t) => (t = t % 360, t < 0 && (t += 360), t), Ms = nn, Rs = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), Ds = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), al = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Rs,
  scaleY: Ds,
  scale: (t) => (Rs(t) + Ds(t)) / 2,
  rotateX: (t) => sn(Tt(Math.atan2(t[6], t[5]))),
  rotateY: (t) => sn(Tt(Math.atan2(-t[2], t[0]))),
  rotateZ: Ms,
  rotate: Ms,
  skewX: (t) => Tt(Math.atan(t[4])),
  skewY: (t) => Tt(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Ls(t) {
  return t.includes("scale") ? 1 : 0;
}
function rn(t, e) {
  if (!t || t === "none")
    return Ls(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let s, i;
  if (n)
    s = al, i = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    s = ol, i = a;
  }
  if (!i)
    return Ls(e);
  const o = s[e], r = i[1].split(",").map(cl);
  return typeof o == "function" ? o(r) : r[o];
}
const ll = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return rn(n, e);
};
function cl(t) {
  return parseFloat(t.trim());
}
const ks = (t) => t === Nt || t === S, ul = /* @__PURE__ */ new Set(["x", "y", "z"]), hl = It.filter((t) => !ul.has(t));
function fl(t) {
  const e = [];
  return hl.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const Bt = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => rn(e, "x"),
  y: (t, { transform: e }) => rn(e, "y")
};
Bt.translateX = Bt.x;
Bt.translateY = Bt.y;
const bt = /* @__PURE__ */ new Set();
let on = !1, an = !1;
function Cr() {
  if (an) {
    const t = Array.from(bt).filter((s) => s.needsMeasurement), e = new Set(t.map((s) => s.element)), n = /* @__PURE__ */ new Map();
    e.forEach((s) => {
      const i = fl(s);
      i.length && (n.set(s, i), s.render());
    }), t.forEach((s) => s.measureInitialState()), e.forEach((s) => {
      s.render();
      const i = n.get(s);
      i && i.forEach(([o, r]) => {
        var a;
        (a = s.getValue(o)) === null || a === void 0 || a.set(r);
      });
    }), t.forEach((s) => s.measureEndState()), t.forEach((s) => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  an = !1, on = !1, bt.forEach((t) => t.complete()), bt.clear();
}
function Er() {
  bt.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (an = !0);
  });
}
function dl() {
  Er(), Cr();
}
class Xn {
  constructor(e, n, s, i, o, r = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = s, this.motionValue = i, this.element = o, this.isAsync = r;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (bt.add(this), on || (on = !0, L.read(Er), L.resolveKeyframes(Cr))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: s, motionValue: i } = this;
    for (let o = 0; o < e.length; o++)
      if (e[o] === null)
        if (o === 0) {
          const r = i?.get(), a = e[e.length - 1];
          if (r !== void 0)
            e[0] = r;
          else if (s && n) {
            const l = s.readValue(n, a);
            l != null && (e[0] = l);
          }
          e[0] === void 0 && (e[0] = a), i && r === void 0 && i.set(e[0]);
        } else
          e[o] = e[o - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), bt.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, bt.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Vr = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), ml = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function pl(t) {
  const e = ml.exec(t);
  if (!e)
    return [,];
  const [, n, s, i] = e;
  return [`--${n ?? s}`, i];
}
const gl = 4;
function Mr(t, e, n = 1) {
  ht(n <= gl, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [s, i] = pl(t);
  if (!s)
    return;
  const o = window.getComputedStyle(e).getPropertyValue(s);
  if (o) {
    const r = o.trim();
    return Vr(r) ? parseFloat(r) : r;
  }
  return Mn(i) ? Mr(i, e, n + 1) : i;
}
const Rr = (t) => (e) => e.test(t), yl = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Dr = [Nt, S, et, ct, ra, ia, yl], js = (t) => Dr.find(Rr(t));
class Lr extends Xn {
  constructor(e, n, s, i, o) {
    super(e, n, s, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: s } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let c = e[l];
      if (typeof c == "string" && (c = c.trim(), Mn(c))) {
        const u = Mr(c, n.current);
        u !== void 0 && (e[l] = u), l === e.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !ir.has(s) || e.length !== 2)
      return;
    const [i, o] = e, r = js(i), a = js(o);
    if (r !== a)
      if (ks(r) && ks(a))
        for (let l = 0; l < e.length; l++) {
          const c = e[l];
          typeof c == "string" && (e[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, s = [];
    for (let i = 0; i < e.length; i++)
      $a(e[i]) && s.push(i);
    s.length && rl(e, s, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: s } = this;
    if (!e || !e.current)
      return;
    s === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Bt[s](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(s, i).jump(i, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: s, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const o = n.getValue(s);
    o && o.jump(this.measuredOrigin, !1);
    const r = i.length - 1, a = i[r];
    i[r] = Bt[s](n.measureViewportBox(), window.getComputedStyle(n.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const Bs = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(dt.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function vl(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function xl(t, e, n, s) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const o = t[t.length - 1], r = Bs(i, e), a = Bs(o, e);
  return Ft(r === a, `You are trying to animate ${e} from "${i}" to "${o}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${o} via the \`style\` property.`), !r || !a ? !1 : vl(t) || (n === "spring" || zn(n)) && s;
}
const Tl = (t) => t !== null;
function De(t, { repeat: e, repeatType: n = "loop" }, s) {
  const i = t.filter(Tl), o = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !o || s === void 0 ? i[o] : s;
}
const bl = 40;
class kr {
  constructor({ autoplay: e = !0, delay: n = 0, type: s = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: r = "loop", ...a }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = nt.now(), this.options = {
      autoplay: e,
      delay: n,
      type: s,
      repeat: i,
      repeatDelay: o,
      repeatType: r,
      ...a
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > bl ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && dl(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.resolvedAt = nt.now(), this.hasAttemptedResolve = !0;
    const { name: s, type: i, velocity: o, delay: r, onComplete: a, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !xl(e, s, i, o))
      if (r)
        this.options.duration = 0;
      else {
        l && l(De(e, this.options, n)), a && a(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(e, n);
    u !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  flatten() {
    this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear");
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
const ln = 2e4;
function jr(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < ln; )
    e += n, s = t.next(e);
  return e >= ln ? 1 / 0 : e;
}
const B = (t, e, n) => t + (e - t) * n;
function Ie(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function wl({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, o = 0, r = 0;
  if (!e)
    i = o = r = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    i = Ie(l, a, t + 1 / 3), o = Ie(l, a, t), r = Ie(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(r * 255),
    alpha: s
  };
}
function Pe(t, e) {
  return (n) => n > 0 ? e : t;
}
const Ne = (t, e, n) => {
  const s = t * t, i = n * (e * e - s) + s;
  return i < 0 ? 0 : Math.sqrt(i);
}, Pl = [tn, xt, Mt], Sl = (t) => Pl.find((e) => e.test(t));
function Os(t) {
  const e = Sl(t);
  if (Ft(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === Mt && (n = wl(n)), n;
}
const Fs = (t, e) => {
  const n = Os(t), s = Os(e);
  if (!n || !s)
    return Pe(t, e);
  const i = { ...n };
  return (o) => (i.red = Ne(n.red, s.red, o), i.green = Ne(n.green, s.green, o), i.blue = Ne(n.blue, s.blue, o), i.alpha = B(n.alpha, s.alpha, o), xt.transform(i));
}, Al = (t, e) => (n) => e(t(n)), ce = (...t) => t.reduce(Al), cn = /* @__PURE__ */ new Set(["none", "hidden"]);
function Cl(t, e) {
  return cn.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function El(t, e) {
  return (n) => B(t, e, n);
}
function qn(t) {
  return typeof t == "number" ? El : typeof t == "string" ? Mn(t) ? Pe : z.test(t) ? Fs : Rl : Array.isArray(t) ? Br : typeof t == "object" ? z.test(t) ? Fs : Vl : Pe;
}
function Br(t, e) {
  const n = [...t], s = n.length, i = t.map((o, r) => qn(o)(o, e[r]));
  return (o) => {
    for (let r = 0; r < s; r++)
      n[r] = i[r](o);
    return n;
  };
}
function Vl(t, e) {
  const n = { ...t, ...e }, s = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (s[i] = qn(t[i])(t[i], e[i]));
  return (i) => {
    for (const o in s)
      n[o] = s[o](i);
    return n;
  };
}
function Ml(t, e) {
  var n;
  const s = [], i = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < e.values.length; o++) {
    const r = e.types[o], a = t.indexes[r][i[r]], l = (n = t.values[a]) !== null && n !== void 0 ? n : 0;
    s[o] = l, i[r]++;
  }
  return s;
}
const Rl = (t, e) => {
  const n = dt.createTransformer(e), s = re(t), i = re(e);
  return s.indexes.var.length === i.indexes.var.length && s.indexes.color.length === i.indexes.color.length && s.indexes.number.length >= i.indexes.number.length ? cn.has(t) && !i.values.length || cn.has(e) && !s.values.length ? Cl(t, e) : ce(Br(Ml(s, i), i.values), n) : (Ft(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Pe(t, e));
};
function Or(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? B(t, e, n) : qn(t)(t, e);
}
const Dl = 5;
function Fr(t, e, n) {
  const s = Math.max(e - Dl, 0);
  return rr(n - t(s), e - s);
}
const j = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, _e = 1e-3;
function Ll({ duration: t = j.duration, bounce: e = j.bounce, velocity: n = j.velocity, mass: s = j.mass }) {
  let i, o;
  Ft(t <= /* @__PURE__ */ st(j.maxDuration), "Spring duration must be 10 seconds or less");
  let r = 1 - e;
  r = at(j.minDamping, j.maxDamping, r), t = at(j.minDuration, j.maxDuration, /* @__PURE__ */ ot(t)), r < 1 ? (i = (c) => {
    const u = c * r, h = u * t, d = u - n, m = un(c, r), p = Math.exp(-h);
    return _e - d / m * p;
  }, o = (c) => {
    const h = c * r * t, d = h * n + n, m = Math.pow(r, 2) * Math.pow(c, 2) * t, p = Math.exp(-h), y = un(Math.pow(c, 2), r);
    return (-i(c) + _e > 0 ? -1 : 1) * ((d - m) * p) / y;
  }) : (i = (c) => {
    const u = Math.exp(-c * t), h = (c - n) * t + 1;
    return -_e + u * h;
  }, o = (c) => {
    const u = Math.exp(-c * t), h = (n - c) * (t * t);
    return u * h;
  });
  const a = 5 / t, l = jl(i, o, a);
  if (t = /* @__PURE__ */ st(t), isNaN(l))
    return {
      stiffness: j.stiffness,
      damping: j.damping,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * s;
    return {
      stiffness: c,
      damping: r * 2 * Math.sqrt(s * c),
      duration: t
    };
  }
}
const kl = 12;
function jl(t, e, n) {
  let s = n;
  for (let i = 1; i < kl; i++)
    s = s - t(s) / e(s);
  return s;
}
function un(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Bl = ["duration", "bounce"], Ol = ["stiffness", "damping", "mass"];
function Is(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Fl(t) {
  let e = {
    velocity: j.velocity,
    stiffness: j.stiffness,
    damping: j.damping,
    mass: j.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Is(t, Ol) && Is(t, Bl))
    if (t.visualDuration) {
      const n = t.visualDuration, s = 2 * Math.PI / (n * 1.2), i = s * s, o = 2 * at(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: j.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = Ll(t);
      e = {
        ...e,
        ...n,
        mass: j.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Ir(t = j.visualDuration, e = j.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: s, restDelta: i } = n;
  const o = n.keyframes[0], r = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: o }, { stiffness: l, damping: c, mass: u, duration: h, velocity: d, isResolvedFromDuration: m } = Fl({
    ...n,
    velocity: -/* @__PURE__ */ ot(n.velocity || 0)
  }), p = d || 0, y = c / (2 * Math.sqrt(l * u)), v = r - o, g = /* @__PURE__ */ ot(Math.sqrt(l / u)), T = Math.abs(v) < 5;
  s || (s = T ? j.restSpeed.granular : j.restSpeed.default), i || (i = T ? j.restDelta.granular : j.restDelta.default);
  let P;
  if (y < 1) {
    const x = un(g, y);
    P = (A) => {
      const D = Math.exp(-y * g * A);
      return r - D * ((p + y * g * v) / x * Math.sin(x * A) + v * Math.cos(x * A));
    };
  } else if (y === 1)
    P = (x) => r - Math.exp(-g * x) * (v + (p + g * v) * x);
  else {
    const x = g * Math.sqrt(y * y - 1);
    P = (A) => {
      const D = Math.exp(-y * g * A), C = Math.min(x * A, 300);
      return r - D * ((p + y * g * v) * Math.sinh(C) + x * v * Math.cosh(C)) / x;
    };
  }
  const M = {
    calculatedDuration: m && h || null,
    next: (x) => {
      const A = P(x);
      if (m)
        a.done = x >= h;
      else {
        let D = 0;
        y < 1 && (D = x === 0 ? /* @__PURE__ */ st(p) : Fr(P, x, A));
        const C = Math.abs(D) <= s, I = Math.abs(r - A) <= i;
        a.done = C && I;
      }
      return a.value = a.done ? r : A, a;
    },
    toString: () => {
      const x = Math.min(jr(M), ln), A = ar((D) => M.next(x * D).value, x, 30);
      return x + "ms " + A;
    }
  };
  return M;
}
function Ns({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: r, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const h = t[0], d = {
    done: !1,
    value: h
  }, m = (C) => a !== void 0 && C < a || l !== void 0 && C > l, p = (C) => a === void 0 ? l : l === void 0 || Math.abs(a - C) < Math.abs(l - C) ? a : l;
  let y = n * e;
  const v = h + y, g = r === void 0 ? v : r(v);
  g !== v && (y = g - h);
  const T = (C) => -y * Math.exp(-C / s), P = (C) => g + T(C), M = (C) => {
    const I = T(C), _ = P(C);
    d.done = Math.abs(I) <= c, d.value = d.done ? g : _;
  };
  let x, A;
  const D = (C) => {
    m(d.value) && (x = C, A = Ir({
      keyframes: [d.value, p(d.value)],
      velocity: Fr(P, C, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: c,
      restSpeed: u
    }));
  };
  return D(0), {
    calculatedDuration: null,
    next: (C) => {
      let I = !1;
      return !A && x === void 0 && (I = !0, M(C), D(C)), x !== void 0 && C >= x ? A.next(C - x) : (!I && M(C), d);
    }
  };
}
const Il = /* @__PURE__ */ le(0.42, 0, 1, 1), Nl = /* @__PURE__ */ le(0, 0, 0.58, 1), Nr = /* @__PURE__ */ le(0.42, 0, 0.58, 1), _l = (t) => Array.isArray(t) && typeof t[0] != "number", _s = {
  linear: G,
  easeIn: Il,
  easeInOut: Nr,
  easeOut: Nl,
  circIn: Kn,
  circInOut: yr,
  circOut: gr,
  backIn: Hn,
  backInOut: mr,
  backOut: dr,
  anticipate: pr
}, Us = (t) => {
  if (Wn(t)) {
    ht(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, s, i] = t;
    return le(e, n, s, i);
  } else if (typeof t == "string")
    return ht(_s[t] !== void 0, `Invalid easing type '${t}'`), _s[t];
  return t;
};
function Ul(t, e, n) {
  const s = [], i = n || Or, o = t.length - 1;
  for (let r = 0; r < o; r++) {
    let a = i(t[r], t[r + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[r] || G : e;
      a = ce(l, a);
    }
    s.push(a);
  }
  return s;
}
function $l(t, e, { clamp: n = !0, ease: s, mixer: i } = {}) {
  const o = t.length;
  if (ht(o === e.length, "Both input and output ranges must be the same length"), o === 1)
    return () => e[0];
  if (o === 2 && e[0] === e[1])
    return () => e[1];
  const r = t[0] === t[1];
  t[0] > t[o - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = Ul(e, s, i), l = a.length, c = (u) => {
    if (r && u < t[0])
      return e[0];
    let h = 0;
    if (l > 1)
      for (; h < t.length - 2 && !(u < t[h + 1]); h++)
        ;
    const d = /* @__PURE__ */ jt(t[h], t[h + 1], u);
    return a[h](d);
  };
  return n ? (u) => c(at(t[0], t[o - 1], u)) : c;
}
function zl(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const i = /* @__PURE__ */ jt(0, e, s);
    t.push(B(n, 1, i));
  }
}
function Wl(t) {
  const e = [0];
  return zl(e, t.length - 1), e;
}
function Hl(t, e) {
  return t.map((n) => n * e);
}
function Kl(t, e) {
  return t.map(() => e || Nr).splice(0, t.length - 1);
}
function qt({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const i = _l(s) ? s.map(Us) : Us(s), o = {
    done: !1,
    value: e[0]
  }, r = Hl(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Wl(e),
    t
  ), a = $l(r, e, {
    ease: Array.isArray(i) ? i : Kl(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (o.value = a(l), o.done = l >= t, o)
  };
}
const Yl = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => L.update(e, !0),
    stop: () => ft(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => U.isProcessing ? U.timestamp : nt.now()
  };
}, Gl = {
  decay: Ns,
  inertia: Ns,
  tween: qt,
  keyframes: qt,
  spring: Ir
}, Xl = (t) => t / 100;
class Zn extends kr {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: s, element: i, keyframes: o } = this.options, r = i?.KeyframeResolver || Xn, a = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new r(o, a, n, s, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: s = 0, repeatDelay: i = 0, repeatType: o, velocity: r = 0 } = this.options, a = zn(n) ? n : Gl[n] || qt;
    let l, c;
    process.env.NODE_ENV !== "production" && a !== qt && ht(e.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), a !== qt && typeof e[0] != "number" && (l = ce(Xl, Or(e[0], e[1])), e = [0, 100]);
    const u = a({ ...this.options, keyframes: e });
    o === "mirror" && (c = a({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -r
    })), u.calculatedDuration === null && (u.calculatedDuration = jr(u));
    const { calculatedDuration: h } = u, d = h + i, m = d * (s + 1) - i;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: h,
      resolvedDuration: d,
      totalDuration: m
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: s } = this;
    if (!s) {
      const { keyframes: C } = this.options;
      return { done: !0, value: C[C.length - 1] };
    }
    const { finalKeyframe: i, generator: o, mirroredGenerator: r, mapPercentToKeyframes: a, keyframes: l, calculatedDuration: c, totalDuration: u, resolvedDuration: h } = s;
    if (this.startTime === null)
      return o.next(0);
    const { delay: d, repeat: m, repeatType: p, repeatDelay: y, onUpdate: v } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - u / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const g = this.currentTime - d * (this.speed >= 0 ? 1 : -1), T = this.speed >= 0 ? g < 0 : g > u;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let P = this.currentTime, M = o;
    if (m) {
      const C = Math.min(this.currentTime, u) / h;
      let I = Math.floor(C), _ = C % 1;
      !_ && C >= 1 && (_ = 1), _ === 1 && I--, I = Math.min(I, m + 1), !!(I % 2) && (p === "reverse" ? (_ = 1 - _, y && (_ -= y / h)) : p === "mirror" && (M = r)), P = at(0, 1, _) * h;
    }
    const x = T ? { done: !1, value: l[0] } : M.next(P);
    a && (x.value = a(x.value));
    let { done: A } = x;
    !T && c !== null && (A = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const D = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return D && i !== void 0 && (x.value = De(l, this.options, i)), v && v(x.value), D && this.finish(), x;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? /* @__PURE__ */ ot(e.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ ot(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ st(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ ot(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = Yl, onPlay: n, startTime: s } = this.options;
    this.driver || (this.driver = e((o) => this.tick(o))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = s ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const ql = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function Zl(t, e, n, { delay: s = 0, duration: i = 300, repeat: o = 0, repeatType: r = "loop", ease: a = "easeInOut", times: l } = {}) {
  const c = { [e]: n };
  l && (c.offset = l);
  const u = cr(a, i);
  return Array.isArray(u) && (c.easing = u), t.animate(c, {
    delay: s,
    duration: i,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: o + 1,
    direction: r === "reverse" ? "alternate" : "normal"
  });
}
const Jl = /* @__PURE__ */ $n(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Se = 10, Ql = 2e4;
function tc(t) {
  return zn(t.type) || t.type === "spring" || !lr(t.ease);
}
function ec(t, e) {
  const n = new Zn({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let s = { done: !1, value: t[0] };
  const i = [];
  let o = 0;
  for (; !s.done && o < Ql; )
    s = n.sample(o), i.push(s.value), o += Se;
  return {
    times: void 0,
    keyframes: i,
    duration: o - Se,
    ease: "linear"
  };
}
const _r = {
  anticipate: pr,
  backInOut: mr,
  circInOut: yr
};
function nc(t) {
  return t in _r;
}
class $s extends kr {
  constructor(e) {
    super(e);
    const { name: n, motionValue: s, element: i, keyframes: o } = this.options;
    this.resolver = new Lr(o, (r, a) => this.onKeyframesResolved(r, a), n, s, i), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    let { duration: s = 300, times: i, ease: o, type: r, motionValue: a, name: l, startTime: c } = this.options;
    if (!a.owner || !a.owner.current)
      return !1;
    if (typeof o == "string" && we() && nc(o) && (o = _r[o]), tc(this.options)) {
      const { onComplete: h, onUpdate: d, motionValue: m, element: p, ...y } = this.options, v = ec(e, y);
      e = v.keyframes, e.length === 1 && (e[1] = e[0]), s = v.duration, i = v.times, o = v.ease, r = "keyframes";
    }
    const u = Zl(a.owner.current, l, e, { ...this.options, duration: s, times: i, ease: o });
    return u.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? (Es(u, this.pendingTimeline), this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: h } = this.options;
      a.set(De(e, this.options, n)), h && h(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: s,
      times: i,
      type: r,
      ease: o,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return /* @__PURE__ */ ot(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return /* @__PURE__ */ ot(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: s } = n;
    s.currentTime = /* @__PURE__ */ st(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: s } = n;
    s.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: n } = e;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return G;
      const { animation: s } = n;
      Es(s, e);
    }
    return G;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: s, duration: i, type: o, ease: r, times: a } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: h, element: d, ...m } = this.options, p = new Zn({
        ...m,
        keyframes: s,
        duration: i,
        type: o,
        ease: r,
        times: a,
        isGenerator: !0
      }), y = /* @__PURE__ */ st(this.time);
      c.setWithVelocity(p.sample(y - Se).value, p.sample(y).value, Se);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: s, repeatDelay: i, repeatType: o, damping: r, type: a } = e;
    if (!n || !n.owner || !(n.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: l, transformTemplate: c } = n.owner.getProps();
    return Jl() && s && ql.has(s) && (s !== "transform" || !c) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !l && !i && o !== "mirror" && r !== 0 && a !== "inertia";
  }
}
const sc = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, ic = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), rc = {
  type: "keyframes",
  duration: 0.8
}, oc = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, ac = (t, { keyframes: e }) => e.length > 2 ? rc : Pt.has(t) ? t.startsWith("scale") ? ic(e[1]) : sc : oc;
function lc({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: i, repeat: o, repeatType: r, repeatDelay: a, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const Jn = (t, e, n, s = {}, i, o) => (r) => {
  const a = In(s, t) || {}, l = a.delay || s.delay || 0;
  let { elapsed: c = 0 } = s;
  c = c - /* @__PURE__ */ st(l);
  let u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (d) => {
      e.set(d), a.onUpdate && a.onUpdate(d);
    },
    onComplete: () => {
      r(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: o ? void 0 : i
  };
  lc(a) || (u = {
    ...u,
    ...ac(t, u)
  }), u.duration && (u.duration = /* @__PURE__ */ st(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ st(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let h = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (h = !0)), u.allowFlatten = !a.type && !a.ease, h && !o && e.get() !== void 0) {
    const d = De(u.keyframes, a);
    if (d !== void 0)
      return L.update(() => {
        u.onUpdate(d), u.onComplete();
      }), new Oa([]);
  }
  return !o && $s.supports(u) ? new $s(u) : new Zn(u);
};
function cc({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function Ur(t, e, { delay: n = 0, transitionOverride: s, type: i } = {}) {
  var o;
  let { transition: r = t.getDefaultTransition(), transitionEnd: a, ...l } = e;
  s && (r = s);
  const c = [], u = i && t.animationState && t.animationState.getState()[i];
  for (const h in l) {
    const d = t.getValue(h, (o = t.latestValues[h]) !== null && o !== void 0 ? o : null), m = l[h];
    if (m === void 0 || u && cc(u, h))
      continue;
    const p = {
      delay: n,
      ...In(r || {}, h)
    };
    let y = !1;
    if (window.MotionHandoffAnimation) {
      const g = or(t);
      if (g) {
        const T = window.MotionHandoffAnimation(g, h, L);
        T !== null && (p.startTime = T, y = !0);
      }
    }
    Je(t, h), d.start(Jn(h, d, m, t.shouldReduceMotion && ir.has(h) ? { type: !1 } : p, t, y));
    const v = d.animation;
    v && c.push(v);
  }
  return a && Promise.all(c).then(() => {
    L.update(() => {
      a && La(t, a);
    });
  }), c;
}
function hn(t, e, n = {}) {
  var s;
  const i = se(t, e, n.type === "exit" ? (s = t.presenceContext) === null || s === void 0 ? void 0 : s.custom : void 0);
  let { transition: o = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (o = n.transitionOverride);
  const r = i ? () => Promise.all(Ur(t, i, n)) : () => Promise.resolve(), a = t.variantChildren && t.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: h, staggerDirection: d } = o;
    return uc(t, e, u + c, h, d, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [r, a] : [a, r];
    return c().then(() => u());
  } else
    return Promise.all([r(), a(n.delay)]);
}
function uc(t, e, n = 0, s = 0, i = 1, o) {
  const r = [], a = (t.variantChildren.size - 1) * s, l = i === 1 ? (c = 0) => c * s : (c = 0) => a - c * s;
  return Array.from(t.variantChildren).sort(hc).forEach((c, u) => {
    c.notify("AnimationStart", e), r.push(hn(c, e, {
      ...o,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(r);
}
function hc(t, e) {
  return t.sortNodePosition(e);
}
function fc(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const i = e.map((o) => hn(t, o, n));
    s = Promise.all(i);
  } else if (typeof e == "string")
    s = hn(t, e, n);
  else {
    const i = typeof e == "function" ? se(t, e, n.custom) : e;
    s = Promise.all(Ur(t, i, n));
  }
  return s.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function $r(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let s = 0; s < n; s++)
    if (e[s] !== t[s])
      return !1;
  return !0;
}
const dc = An.length;
function zr(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? zr(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < dc; n++) {
    const s = An[n], i = t.props[s];
    (te(i) || i === !1) && (e[s] = i);
  }
  return e;
}
const mc = [...Sn].reverse(), pc = Sn.length;
function gc(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: s }) => fc(t, n, s)));
}
function yc(t) {
  let e = gc(t), n = zs(), s = !0;
  const i = (l) => (c, u) => {
    var h;
    const d = se(t, u, l === "exit" ? (h = t.presenceContext) === null || h === void 0 ? void 0 : h.custom : void 0);
    if (d) {
      const { transition: m, transitionEnd: p, ...y } = d;
      c = { ...c, ...y, ...p };
    }
    return c;
  };
  function o(l) {
    e = l(t);
  }
  function r(l) {
    const { props: c } = t, u = zr(t.parent) || {}, h = [], d = /* @__PURE__ */ new Set();
    let m = {}, p = 1 / 0;
    for (let v = 0; v < pc; v++) {
      const g = mc[v], T = n[g], P = c[g] !== void 0 ? c[g] : u[g], M = te(P), x = g === l ? T.isActive : null;
      x === !1 && (p = v);
      let A = P === u[g] && P !== c[g] && M;
      if (A && s && t.manuallyAnimateOnMount && (A = !1), T.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !T.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !P && !T.prevProp || // Or if the prop doesn't define an animation
      Me(P) || typeof P == "boolean")
        continue;
      const D = vc(T.prevProp, P);
      let C = D || // If we're making this variant active, we want to always make it active
      g === l && T.isActive && !A && M || // If we removed a higher-priority variant (i is in reverse order)
      v > p && M, I = !1;
      const _ = Array.isArray(P) ? P : [P];
      let tt = _.reduce(i(g), {});
      x === !1 && (tt = {});
      const { prevResolvedValues: St = {} } = T, _t = {
        ...St,
        ...tt
      }, At = (N) => {
        C = !0, d.has(N) && (I = !0, d.delete(N)), T.needsAnimating[N] = !0;
        const Z = t.getValue(N);
        Z && (Z.liveStyle = !1);
      };
      for (const N in _t) {
        const Z = tt[N], J = St[N];
        if (m.hasOwnProperty(N))
          continue;
        let Ct = !1;
        Ze(Z) && Ze(J) ? Ct = !$r(Z, J) : Ct = Z !== J, Ct ? Z != null ? At(N) : d.add(N) : Z !== void 0 && d.has(N) ? At(N) : T.protectedKeys[N] = !0;
      }
      T.prevProp = P, T.prevResolvedValues = tt, T.isActive && (m = { ...m, ...tt }), s && t.blockInitialAnimation && (C = !1), C && (!(A && D) || I) && h.push(..._.map((N) => ({
        animation: N,
        options: { type: g }
      })));
    }
    if (d.size) {
      const v = {};
      if (typeof c.initial != "boolean") {
        const g = se(t, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        g && g.transition && (v.transition = g.transition);
      }
      d.forEach((g) => {
        const T = t.getBaseTarget(g), P = t.getValue(g);
        P && (P.liveStyle = !0), v[g] = T ?? null;
      }), h.push({ animation: v });
    }
    let y = !!h.length;
    return s && (c.initial === !1 || c.initial === c.animate) && !t.manuallyAnimateOnMount && (y = !1), s = !1, y ? e(h) : Promise.resolve();
  }
  function a(l, c) {
    var u;
    if (n[l].isActive === c)
      return Promise.resolve();
    (u = t.variantChildren) === null || u === void 0 || u.forEach((d) => {
      var m;
      return (m = d.animationState) === null || m === void 0 ? void 0 : m.setActive(l, c);
    }), n[l].isActive = c;
    const h = r(l);
    for (const d in n)
      n[d].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: r,
    setActive: a,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = zs(), s = !0;
    }
  };
}
function vc(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !$r(e, t) : !1;
}
function yt(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function zs() {
  return {
    animate: yt(!0),
    whileInView: yt(),
    whileHover: yt(),
    whileTap: yt(),
    whileDrag: yt(),
    whileFocus: yt(),
    exit: yt()
  };
}
class mt {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class xc extends mt {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = yc(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    Me(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let Tc = 0;
class bc extends mt {
  constructor() {
    super(...arguments), this.id = Tc++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: s } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === s)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const wc = {
  animation: {
    Feature: xc
  },
  exit: {
    Feature: bc
  }
}, Q = {
  x: !1,
  y: !1
};
function Wr() {
  return Q.x || Q.y;
}
function Pc(t) {
  return t === "x" || t === "y" ? Q[t] ? null : (Q[t] = !0, () => {
    Q[t] = !1;
  }) : Q.x || Q.y ? null : (Q.x = Q.y = !0, () => {
    Q.x = Q.y = !1;
  });
}
function oe(t, e, n, s = { passive: !0 }) {
  return t.addEventListener(e, n, s), () => t.removeEventListener(e, n);
}
const Qn = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function ue(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Sc = (t) => (e) => Qn(e) && t(e, ue(e));
function Zt(t, e, n, s) {
  return oe(t, e, Sc(n), s);
}
function Hr({ top: t, left: e, right: n, bottom: s }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: s }
  };
}
function Ac({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function Cc(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), s = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: s.y,
    right: s.x
  };
}
const Kr = 1e-4, Ec = 1 - Kr, Vc = 1 + Kr, Yr = 0.01, Mc = 0 - Yr, Rc = 0 + Yr;
function Y(t) {
  return t.max - t.min;
}
function Dc(t, e, n) {
  return Math.abs(t - e) <= n;
}
function Ws(t, e, n, s = 0.5) {
  t.origin = s, t.originPoint = B(e.min, e.max, t.origin), t.scale = Y(n) / Y(e), t.translate = B(n.min, n.max, t.origin) - t.originPoint, (t.scale >= Ec && t.scale <= Vc || isNaN(t.scale)) && (t.scale = 1), (t.translate >= Mc && t.translate <= Rc || isNaN(t.translate)) && (t.translate = 0);
}
function Jt(t, e, n, s) {
  Ws(t.x, e.x, n.x, s ? s.originX : void 0), Ws(t.y, e.y, n.y, s ? s.originY : void 0);
}
function Hs(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + Y(e);
}
function Lc(t, e, n) {
  Hs(t.x, e.x, n.x), Hs(t.y, e.y, n.y);
}
function Ks(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + Y(e);
}
function Qt(t, e, n) {
  Ks(t.x, e.x, n.x), Ks(t.y, e.y, n.y);
}
const Ys = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Rt = () => ({
  x: Ys(),
  y: Ys()
}), Gs = () => ({ min: 0, max: 0 }), F = () => ({
  x: Gs(),
  y: Gs()
});
function q(t) {
  return [t("x"), t("y")];
}
function Ue(t) {
  return t === void 0 || t === 1;
}
function fn({ scale: t, scaleX: e, scaleY: n }) {
  return !Ue(t) || !Ue(e) || !Ue(n);
}
function vt(t) {
  return fn(t) || Gr(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function Gr(t) {
  return Xs(t.x) || Xs(t.y);
}
function Xs(t) {
  return t && t !== "0%";
}
function Ae(t, e, n) {
  const s = t - n, i = e * s;
  return n + i;
}
function qs(t, e, n, s, i) {
  return i !== void 0 && (t = Ae(t, i, s)), Ae(t, n, s) + e;
}
function dn(t, e = 0, n = 1, s, i) {
  t.min = qs(t.min, e, n, s, i), t.max = qs(t.max, e, n, s, i);
}
function Xr(t, { x: e, y: n }) {
  dn(t.x, e.translate, e.scale, e.originPoint), dn(t.y, n.translate, n.scale, n.originPoint);
}
const Zs = 0.999999999999, Js = 1.0000000000001;
function kc(t, e, n, s = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let o, r;
  for (let a = 0; a < i; a++) {
    o = n[a], r = o.projectionDelta;
    const { visualElement: l } = o.options;
    l && l.props.style && l.props.style.display === "contents" || (s && o.options.layoutScroll && o.scroll && o !== o.root && Lt(t, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), r && (e.x *= r.x.scale, e.y *= r.y.scale, Xr(t, r)), s && vt(o.latestValues) && Lt(t, o.latestValues));
  }
  e.x < Js && e.x > Zs && (e.x = 1), e.y < Js && e.y > Zs && (e.y = 1);
}
function Dt(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function Qs(t, e, n, s, i = 0.5) {
  const o = B(t.min, t.max, i);
  dn(t, e, n, o, s);
}
function Lt(t, e) {
  Qs(t.x, e.x, e.scaleX, e.scale, e.originX), Qs(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function qr(t, e) {
  return Hr(Cc(t.getBoundingClientRect(), e));
}
function jc(t, e, n) {
  const s = qr(t, n), { scroll: i } = e;
  return i && (Dt(s.x, i.offset.x), Dt(s.y, i.offset.y)), s;
}
const Zr = ({ current: t }) => t ? t.ownerDocument.defaultView : null, ti = (t, e) => Math.abs(t - e);
function Bc(t, e) {
  const n = ti(t.x, e.x), s = ti(t.y, e.y);
  return Math.sqrt(n ** 2 + s ** 2);
}
class Jr {
  constructor(e, n, { transformPagePoint: s, contextWindow: i, dragSnapToOrigin: o = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = ze(this.lastMoveEventInfo, this.history), d = this.startEvent !== null, m = Bc(h.offset, { x: 0, y: 0 }) >= 3;
      if (!d && !m)
        return;
      const { point: p } = h, { timestamp: y } = U;
      this.history.push({ ...p, timestamp: y });
      const { onStart: v, onMove: g } = this.handlers;
      d || (v && v(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), g && g(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, d) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = $e(d, this.transformPagePoint), L.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, d) => {
      this.end();
      const { onEnd: m, onSessionEnd: p, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const v = ze(h.type === "pointercancel" ? this.lastMoveEventInfo : $e(d, this.transformPagePoint), this.history);
      this.startEvent && m && m(h, v), p && p(h, v);
    }, !Qn(e))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = s, this.contextWindow = i || window;
    const r = ue(e), a = $e(r, this.transformPagePoint), { point: l } = a, { timestamp: c } = U;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(e, ze(a, this.history)), this.removeListeners = ce(Zt(this.contextWindow, "pointermove", this.handlePointerMove), Zt(this.contextWindow, "pointerup", this.handlePointerUp), Zt(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), ft(this.updatePoint);
  }
}
function $e(t, e) {
  return e ? { point: e(t.point) } : t;
}
function ei(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function ze({ point: t }, e) {
  return {
    point: t,
    delta: ei(t, Qr(e)),
    offset: ei(t, Oc(e)),
    velocity: Fc(e, 0.1)
  };
}
function Oc(t) {
  return t[0];
}
function Qr(t) {
  return t[t.length - 1];
}
function Fc(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, s = null;
  const i = Qr(t);
  for (; n >= 0 && (s = t[n], !(i.timestamp - s.timestamp > /* @__PURE__ */ st(e))); )
    n--;
  if (!s)
    return { x: 0, y: 0 };
  const o = /* @__PURE__ */ ot(i.timestamp - s.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const r = {
    x: (i.x - s.x) / o,
    y: (i.y - s.y) / o
  };
  return r.x === 1 / 0 && (r.x = 0), r.y === 1 / 0 && (r.y = 0), r;
}
function Ic(t, { min: e, max: n }, s) {
  return e !== void 0 && t < e ? t = s ? B(e, t, s.min) : Math.max(t, e) : n !== void 0 && t > n && (t = s ? B(n, t, s.max) : Math.min(t, n)), t;
}
function ni(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Nc(t, { top: e, left: n, bottom: s, right: i }) {
  return {
    x: ni(t.x, n, i),
    y: ni(t.y, e, s)
  };
}
function si(t, e) {
  let n = e.min - t.min, s = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, s] = [s, n]), { min: n, max: s };
}
function _c(t, e) {
  return {
    x: si(t.x, e.x),
    y: si(t.y, e.y)
  };
}
function Uc(t, e) {
  let n = 0.5;
  const s = Y(t), i = Y(e);
  return i > s ? n = /* @__PURE__ */ jt(e.min, e.max - s, t.min) : s > i && (n = /* @__PURE__ */ jt(t.min, t.max - i, e.min)), at(0, 1, n);
}
function $c(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const mn = 0.35;
function zc(t = mn) {
  return t === !1 ? t = 0 : t === !0 && (t = mn), {
    x: ii(t, "left", "right"),
    y: ii(t, "top", "bottom")
  };
}
function ii(t, e, n) {
  return {
    min: ri(t, e),
    max: ri(t, n)
  };
}
function ri(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const Wc = /* @__PURE__ */ new WeakMap();
class Hc {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = F(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const i = (u) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(ue(u).point);
    }, o = (u, h) => {
      const { drag: d, dragPropagation: m, onDragStart: p } = this.getProps();
      if (d && !m && (this.openDragLock && this.openDragLock(), this.openDragLock = Pc(d), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), q((v) => {
        let g = this.getAxisMotionValue(v).get() || 0;
        if (et.test(g)) {
          const { projection: T } = this.visualElement;
          if (T && T.layout) {
            const P = T.layout.layoutBox[v];
            P && (g = Y(P) * (parseFloat(g) / 100));
          }
        }
        this.originPoint[v] = g;
      }), p && L.postRender(() => p(u, h)), Je(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, r = (u, h) => {
      const { dragPropagation: d, dragDirectionLock: m, onDirectionLock: p, onDrag: y } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: v } = h;
      if (m && this.currentDirection === null) {
        this.currentDirection = Kc(v), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, v), this.updateAxis("y", h.point, v), this.visualElement.render(), y && y(u, h);
    }, a = (u, h) => this.stop(u, h), l = () => q((u) => {
      var h;
      return this.getAnimationState(u) === "paused" && ((h = this.getAxisMotionValue(u).animation) === null || h === void 0 ? void 0 : h.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Jr(e, {
      onSessionStart: i,
      onStart: o,
      onMove: r,
      onSessionEnd: a,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: Zr(this.visualElement)
    });
  }
  stop(e, n) {
    const s = this.isDragging;
    if (this.cancel(), !s)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: o } = this.getProps();
    o && L.postRender(() => o(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: s } = this.getProps();
    !s && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, s) {
    const { drag: i } = this.getProps();
    if (!s || !ye(e, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(e);
    let r = this.originPoint[e] + s[e];
    this.constraints && this.constraints[e] && (r = Ic(r, this.constraints[e], this.elastic[e])), o.set(r);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: n, dragElastic: s } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, o = this.constraints;
    n && Vt(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = Nc(i.layoutBox, n) : this.constraints = !1, this.elastic = zc(s), o !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && q((r) => {
      this.constraints !== !1 && this.getAxisMotionValue(r) && (this.constraints[r] = $c(i.layoutBox[r], this.constraints[r]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !Vt(e))
      return !1;
    const s = e.current;
    ht(s !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = jc(s, i.root, this.visualElement.getTransformPagePoint());
    let r = _c(i.layout.layoutBox, o);
    if (n) {
      const a = n(Ac(r));
      this.hasMutatedConstraints = !!a, a && (r = Hr(a));
    }
    return r;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: s, dragElastic: i, dragTransition: o, dragSnapToOrigin: r, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = q((u) => {
      if (!ye(u, n, this.currentDirection))
        return;
      let h = l && l[u] || {};
      r && (h = { min: 0, max: 0 });
      const d = i ? 200 : 1e6, m = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: s ? e[u] : 0,
        bounceStiffness: d,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...h
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(e, n) {
    const s = this.getAxisMotionValue(e);
    return Je(this.visualElement, e), s.start(Jn(e, s, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    q((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    q((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, s = this.visualElement.getProps(), i = s[n];
    return i || this.visualElement.getValue(e, (s.initial ? s.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    q((n) => {
      const { drag: s } = this.getProps();
      if (!ye(n, s, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: r, max: a } = i.layout.layoutBox[n];
        o.set(e[n] - B(r, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: s } = this.visualElement;
    if (!Vt(n) || !s || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    q((r) => {
      const a = this.getAxisMotionValue(r);
      if (a && this.constraints !== !1) {
        const l = a.get();
        i[r] = Uc({ min: l, max: l }, this.constraints[r]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", s.root && s.root.updateScroll(), s.updateLayout(), this.resolveConstraints(), q((r) => {
      if (!ye(r, e, null))
        return;
      const a = this.getAxisMotionValue(r), { min: l, max: c } = this.constraints[r];
      a.set(B(l, c, i[r]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Wc.set(this.visualElement, this);
    const e = this.visualElement.current, n = Zt(e, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), s = () => {
      const { dragConstraints: l } = this.getProps();
      Vt(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", s);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), L.read(s);
    const r = oe(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (q((u) => {
        const h = this.getAxisMotionValue(u);
        h && (this.originPoint[u] += l[u].translate, h.set(h.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      r(), n(), o(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: s = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: r = mn, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: s,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: r,
      dragMomentum: a
    };
  }
}
function ye(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function Kc(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class Yc extends mt {
  constructor(e) {
    super(e), this.removeGroupControls = G, this.removeListeners = G, this.controls = new Hc(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || G;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const oi = (t) => (e, n) => {
  t && L.postRender(() => t(e, n));
};
class Gc extends mt {
  constructor() {
    super(...arguments), this.removePointerDownListener = G;
  }
  onPointerDown(e) {
    this.session = new Jr(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Zr(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: s, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: oi(e),
      onStart: oi(n),
      onMove: s,
      onEnd: (o, r) => {
        delete this.session, i && L.postRender(() => i(o, r));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Zt(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Te = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function ai(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Kt = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (S.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = ai(t, e.target.x), s = ai(t, e.target.y);
    return `${n}% ${s}%`;
  }
}, Xc = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const s = t, i = dt.parse(t);
    if (i.length > 5)
      return s;
    const o = dt.createTransformer(t), r = typeof i[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    i[0 + r] /= a, i[1 + r] /= l;
    const c = B(a, l, 0.5);
    return typeof i[2 + r] == "number" && (i[2 + r] /= c), typeof i[3 + r] == "number" && (i[3 + r] /= c), o(i);
  }
};
class qc extends wo {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s, layoutId: i } = this.props, { projection: o } = e;
    sa(Zc), o && (n.group && n.group.add(o), s && s.register && i && s.register(o), o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), Te.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: s, drag: i, isPresent: o } = this.props, r = s.projection;
    return r && (r.isPresent = o, i || e.layoutDependency !== n || n === void 0 || e.isPresent !== o ? r.willUpdate() : this.safeToRemove(), e.isPresent !== o && (o ? r.promote() : r.relegate() || L.postRender(() => {
      const a = r.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), Cn.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), s && s.deregister && s.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function to(t) {
  const [e, n] = Ni(), s = W(Tn);
  return V.jsx(qc, { ...t, layoutGroup: s, switchLayoutGroup: W(Hi), isPresent: e, safeToRemove: n });
}
const Zc = {
  borderRadius: {
    ...Kt,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Kt,
  borderTopRightRadius: Kt,
  borderBottomLeftRadius: Kt,
  borderBottomRightRadius: Kt,
  boxShadow: Xc
};
function Jc(t, e, n) {
  const s = H(t) ? t : ie(t);
  return s.start(Jn("", s, e, n)), s.animation;
}
function Qc(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
const tu = (t, e) => t.depth - e.depth;
class eu {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    Nn(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    _n(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(tu), this.isDirty = !1, this.children.forEach(e);
  }
}
function nu(t, e) {
  const n = nt.now(), s = ({ timestamp: i }) => {
    const o = i - n;
    o >= e && (ft(s), t(o - e));
  };
  return L.read(s, !0), () => ft(s);
}
const eo = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], su = eo.length, li = (t) => typeof t == "string" ? parseFloat(t) : t, ci = (t) => typeof t == "number" || S.test(t);
function iu(t, e, n, s, i, o) {
  i ? (t.opacity = B(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    ru(s)
  ), t.opacityExit = B(e.opacity !== void 0 ? e.opacity : 1, 0, ou(s))) : o && (t.opacity = B(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, s));
  for (let r = 0; r < su; r++) {
    const a = `border${eo[r]}Radius`;
    let l = ui(e, a), c = ui(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || ci(l) === ci(c) ? (t[a] = Math.max(B(li(l), li(c), s), 0), (et.test(c) || et.test(l)) && (t[a] += "%")) : t[a] = c;
  }
  (e.rotate || n.rotate) && (t.rotate = B(e.rotate || 0, n.rotate || 0, s));
}
function ui(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const ru = /* @__PURE__ */ no(0, 0.5, gr), ou = /* @__PURE__ */ no(0.5, 0.95, G);
function no(t, e, n) {
  return (s) => s < t ? 0 : s > e ? 1 : n(/* @__PURE__ */ jt(t, e, s));
}
function hi(t, e) {
  t.min = e.min, t.max = e.max;
}
function X(t, e) {
  hi(t.x, e.x), hi(t.y, e.y);
}
function fi(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function di(t, e, n, s, i) {
  return t -= e, t = Ae(t, 1 / n, s), i !== void 0 && (t = Ae(t, 1 / i, s)), t;
}
function au(t, e = 0, n = 1, s = 0.5, i, o = t, r = t) {
  if (et.test(e) && (e = parseFloat(e), e = B(r.min, r.max, e / 100) - r.min), typeof e != "number")
    return;
  let a = B(o.min, o.max, s);
  t === o && (a -= e), t.min = di(t.min, e, n, a, i), t.max = di(t.max, e, n, a, i);
}
function mi(t, e, [n, s, i], o, r) {
  au(t, e[n], e[s], e[i], e.scale, o, r);
}
const lu = ["x", "scaleX", "originX"], cu = ["y", "scaleY", "originY"];
function pi(t, e, n, s) {
  mi(t.x, e, lu, n ? n.x : void 0, s ? s.x : void 0), mi(t.y, e, cu, n ? n.y : void 0, s ? s.y : void 0);
}
function gi(t) {
  return t.translate === 0 && t.scale === 1;
}
function so(t) {
  return gi(t.x) && gi(t.y);
}
function yi(t, e) {
  return t.min === e.min && t.max === e.max;
}
function uu(t, e) {
  return yi(t.x, e.x) && yi(t.y, e.y);
}
function vi(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function io(t, e) {
  return vi(t.x, e.x) && vi(t.y, e.y);
}
function xi(t) {
  return Y(t.x) / Y(t.y);
}
function Ti(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class hu {
  constructor() {
    this.members = [];
  }
  add(e) {
    Nn(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (_n(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let s;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        s = o;
        break;
      }
    }
    return s ? (this.promote(s), !0) : !1;
  }
  promote(e, n) {
    const s = this.lead;
    if (e !== s && (this.prevLead = s, this.lead = e, e.show(), s)) {
      s.instance && s.scheduleRender(), e.scheduleRender(), e.resumeFrom = s, n && (e.resumeFrom.preserveOpacity = !0), s.snapshot && (e.snapshot = s.snapshot, e.snapshot.latestValues = s.animationValues || s.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && s.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: s } = e;
      n.onExitComplete && n.onExitComplete(), s && s.options.onExitComplete && s.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function fu(t, e, n) {
  let s = "";
  const i = t.x.translate / e.x, o = t.y.translate / e.y, r = n?.z || 0;
  if ((i || o || r) && (s = `translate3d(${i}px, ${o}px, ${r}px) `), (e.x !== 1 || e.y !== 1) && (s += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: h, rotateY: d, skewX: m, skewY: p } = n;
    c && (s = `perspective(${c}px) ${s}`), u && (s += `rotate(${u}deg) `), h && (s += `rotateX(${h}deg) `), d && (s += `rotateY(${d}deg) `), m && (s += `skewX(${m}deg) `), p && (s += `skewY(${p}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (s += `scale(${a}, ${l})`), s || "none";
}
const We = ["", "X", "Y", "Z"], du = { visibility: "hidden" }, bi = 1e3;
let mu = 0;
function He(t, e, n, s) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), s && (s[t] = 0));
}
function ro(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = or(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", L, !(i || o));
  }
  const { parent: s } = t;
  s && !s.hasCheckedOptimisedAppear && ro(s);
}
function oo({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: s, resetTransform: i }) {
  return class {
    constructor(r = {}, a = e?.()) {
      this.id = mu++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(yu), this.nodes.forEach(wu), this.nodes.forEach(Pu), this.nodes.forEach(vu);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = r, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new eu());
    }
    addEventListener(r, a) {
      return this.eventHandlers.has(r) || this.eventHandlers.set(r, new Un()), this.eventHandlers.get(r).add(a);
    }
    notifyListeners(r, ...a) {
      const l = this.eventHandlers.get(r);
      l && l.notify(...a);
    }
    hasListeners(r) {
      return this.eventHandlers.has(r);
    }
    /**
     * Lifecycles
     */
    mount(r, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = Qc(r), this.instance = r;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(r), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (c || l) && (this.isLayoutDirty = !0), t) {
        let h;
        const d = () => this.root.updateBlockedByResize = !1;
        t(r, () => {
          this.root.updateBlockedByResize = !0, h && h(), h = nu(d, 250), Te.hasAnimatedSinceResize && (Te.hasAnimatedSinceResize = !1, this.nodes.forEach(Pi));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: h, hasLayoutChanged: d, hasRelativeLayoutChanged: m, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || Vu, { onLayoutAnimationStart: v, onLayoutAnimationComplete: g } = u.getProps(), T = !this.targetLayout || !io(this.targetLayout, p), P = !d && m;
        if (this.options.layoutRoot || this.resumeFrom || P || d && (T || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(h, P);
          const M = {
            ...In(y, "layout"),
            onPlay: v,
            onComplete: g
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (M.delay = 0, M.type = !1), this.startAnimation(M);
        } else
          d || Pi(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const r = this.getStack();
      r && r.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, ft(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Su), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: r } = this.options;
      return r && r.getProps().transformTemplate;
    }
    willUpdate(r = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && ro(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const h = this.path[u];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), r && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(wi);
        return;
      }
      this.isUpdating || this.nodes.forEach(Tu), this.isUpdating = !1, this.nodes.forEach(bu), this.nodes.forEach(pu), this.nodes.forEach(gu), this.clearAllSnapshots();
      const a = nt.now();
      U.delta = at(0, 1e3 / 60, a - U.timestamp), U.timestamp = a, U.isProcessing = !0, Oe.update.process(U), Oe.preRender.process(U), Oe.render.process(U), U.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Cn.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(xu), this.sharedNodes.forEach(Au);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, L.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      L.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Y(this.snapshot.measuredBox.x) && !Y(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const r = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = F(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, r ? r.layoutBox : void 0);
    }
    updateScroll(r = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === r && (a = !1), a) {
        const l = s(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: r,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const r = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !so(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      r && (a || vt(this.latestValues) || u) && (i(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(r = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return r && (l = this.removeTransform(l)), Mu(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var r;
      const { visualElement: a } = this.options;
      if (!a)
        return F();
      const l = a.measureViewportBox();
      if (!(((r = this.scroll) === null || r === void 0 ? void 0 : r.wasRoot) || this.path.some(Ru))) {
        const { scroll: u } = this.root;
        u && (Dt(l.x, u.offset.x), Dt(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(r) {
      var a;
      const l = F();
      if (X(l, r), !((a = this.scroll) === null || a === void 0) && a.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: h, options: d } = u;
        u !== this.root && h && d.layoutScroll && (h.wasRoot && X(l, r), Dt(l.x, h.offset.x), Dt(l.y, h.offset.y));
      }
      return l;
    }
    applyTransform(r, a = !1) {
      const l = F();
      X(l, r);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && Lt(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), vt(u.latestValues) && Lt(l, u.latestValues);
      }
      return vt(this.latestValues) && Lt(l, this.latestValues), l;
    }
    removeTransform(r) {
      const a = F();
      X(a, r);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !vt(c.latestValues))
          continue;
        fn(c.latestValues) && c.updateSnapshot();
        const u = F(), h = c.measurePageBox();
        X(u, h), pi(a, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return vt(this.latestValues) && pi(a, this.latestValues), a;
    }
    setTargetDelta(r) {
      this.targetDelta = r, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(r) {
      this.options = {
        ...this.options,
        ...r,
        crossfade: r.crossfade !== void 0 ? r.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== U.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(r = !1) {
      var a;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(r || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: h, layoutId: d } = this.options;
      if (!(!this.layout || !(h || d))) {
        if (this.resolvedRelativeTargetAt = U.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = F(), this.relativeTargetOrigin = F(), Qt(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), X(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = F(), this.targetWithTransforms = F()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Lc(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : X(this.target, this.layout.layoutBox), Xr(this.target, this.targetDelta)) : X(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const m = this.getClosestProjectingParent();
          m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = F(), this.relativeTargetOrigin = F(), Qt(this.relativeTargetOrigin, this.target, m.target), X(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || fn(this.parent.latestValues) || Gr(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var r;
      const a = this.getLead(), l = !!this.resumingFrom || this !== a;
      let c = !0;
      if ((this.isProjectionDirty || !((r = this.parent) === null || r === void 0) && r.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === U.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: h } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || h))
        return;
      X(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, m = this.treeScale.y;
      kc(this.layoutCorrected, this.treeScale, this.path, l), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = F());
      const { target: p } = a;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (fi(this.prevProjectionDelta.x, this.projectionDelta.x), fi(this.prevProjectionDelta.y, this.projectionDelta.y)), Jt(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== m || !Ti(this.projectionDelta.x, this.prevProjectionDelta.x) || !Ti(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(r = !0) {
      var a;
      if ((a = this.options.visualElement) === null || a === void 0 || a.scheduleRender(), r) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Rt(), this.projectionDelta = Rt(), this.projectionDeltaWithTransform = Rt();
    }
    setAnimationOrigin(r, a = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, h = Rt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const d = F(), m = l ? l.source : void 0, p = this.layout ? this.layout.source : void 0, y = m !== p, v = this.getStack(), g = !v || v.members.length <= 1, T = !!(y && !g && this.options.crossfade === !0 && !this.path.some(Eu));
      this.animationProgress = 0;
      let P;
      this.mixTargetDelta = (M) => {
        const x = M / 1e3;
        Si(h.x, r.x, x), Si(h.y, r.y, x), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Qt(d, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Cu(this.relativeTarget, this.relativeTargetOrigin, d, x), P && uu(this.relativeTarget, P) && (this.isProjectionDirty = !1), P || (P = F()), X(P, this.relativeTarget)), y && (this.animationValues = u, iu(u, c, this.latestValues, x, T, g)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = x;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(r) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (ft(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = L.update(() => {
        Te.hasAnimatedSinceResize = !0, this.currentAnimation = Jc(0, bi, {
          ...r,
          onUpdate: (a) => {
            this.mixTargetDelta(a), r.onUpdate && r.onUpdate(a);
          },
          onStop: () => {
          },
          onComplete: () => {
            r.onComplete && r.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const r = this.getStack();
      r && r.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(bi), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const r = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = r;
      if (!(!a || !l || !c)) {
        if (this !== r && this.layout && c && ao(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || F();
          const h = Y(this.layout.layoutBox.x);
          l.x.min = r.target.x.min, l.x.max = l.x.min + h;
          const d = Y(this.layout.layoutBox.y);
          l.y.min = r.target.y.min, l.y.max = l.y.min + d;
        }
        X(a, l), Lt(a, u), Jt(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(r, a) {
      this.sharedNodes.has(r) || this.sharedNodes.set(r, new hu()), this.sharedNodes.get(r).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const r = this.getStack();
      return r ? r.lead === this : !0;
    }
    getLead() {
      var r;
      const { layoutId: a } = this.options;
      return a ? ((r = this.getStack()) === null || r === void 0 ? void 0 : r.lead) || this : this;
    }
    getPrevLead() {
      var r;
      const { layoutId: a } = this.options;
      return a ? (r = this.getStack()) === null || r === void 0 ? void 0 : r.prevLead : void 0;
    }
    getStack() {
      const { layoutId: r } = this.options;
      if (r)
        return this.root.sharedNodes.get(r);
    }
    promote({ needsReset: r, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), r && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const r = this.getStack();
      return r ? r.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: r } = this.options;
      if (!r)
        return;
      let a = !1;
      const { latestValues: l } = r;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && He("z", r, c, this.animationValues);
      for (let u = 0; u < We.length; u++)
        He(`rotate${We[u]}`, r, c, this.animationValues), He(`skew${We[u]}`, r, c, this.animationValues);
      r.render();
      for (const u in c)
        r.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      r.scheduleRender();
    }
    getProjectionStyles(r) {
      var a, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return du;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = ve(r?.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const h = this.getLead();
      if (!this.projectionDelta || !this.layout || !h.target) {
        const y = {};
        return this.options.layoutId && (y.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, y.pointerEvents = ve(r?.pointerEvents) || ""), this.hasProjected && !vt(this.latestValues) && (y.transform = u ? u({}, "") : "none", this.hasProjected = !1), y;
      }
      const d = h.animationValues || h.latestValues;
      this.applyTransformsToTarget(), c.transform = fu(this.projectionDeltaWithTransform, this.treeScale, d), u && (c.transform = u(d, c.transform));
      const { x: m, y: p } = this.projectionDelta;
      c.transformOrigin = `${m.origin * 100}% ${p.origin * 100}% 0`, h.animationValues ? c.opacity = h === this ? (l = (a = d.opacity) !== null && a !== void 0 ? a : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : d.opacityExit : c.opacity = h === this ? d.opacity !== void 0 ? d.opacity : "" : d.opacityExit !== void 0 ? d.opacityExit : 0;
      for (const y in ee) {
        if (d[y] === void 0)
          continue;
        const { correct: v, applyTo: g, isCSSVariable: T } = ee[y], P = c.transform === "none" ? d[y] : v(d[y], h);
        if (g) {
          const M = g.length;
          for (let x = 0; x < M; x++)
            c[g[x]] = P;
        } else
          T ? this.options.visualElement.renderState.vars[y] = P : c[y] = P;
      }
      return this.options.layoutId && (c.pointerEvents = h === this ? ve(r?.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((r) => {
        var a;
        return (a = r.currentAnimation) === null || a === void 0 ? void 0 : a.stop();
      }), this.root.nodes.forEach(wi), this.root.sharedNodes.clear();
    }
  };
}
function pu(t) {
  t.updateLayout();
}
function gu(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: s, measuredBox: i } = t.layout, { animationType: o } = t.options, r = n.source !== t.layout.source;
    o === "size" ? q((h) => {
      const d = r ? n.measuredBox[h] : n.layoutBox[h], m = Y(d);
      d.min = s[h].min, d.max = d.min + m;
    }) : ao(o, n.layoutBox, s) && q((h) => {
      const d = r ? n.measuredBox[h] : n.layoutBox[h], m = Y(s[h]);
      d.max = d.min + m, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[h].max = t.relativeTarget[h].min + m);
    });
    const a = Rt();
    Jt(a, s, n.layoutBox);
    const l = Rt();
    r ? Jt(l, t.applyTransform(i, !0), n.measuredBox) : Jt(l, s, n.layoutBox);
    const c = !so(a);
    let u = !1;
    if (!t.resumeFrom) {
      const h = t.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: d, layout: m } = h;
        if (d && m) {
          const p = F();
          Qt(p, n.layoutBox, d.layoutBox);
          const y = F();
          Qt(y, s, m.layoutBox), io(p, y) || (u = !0), h.options.layoutRoot && (t.relativeTarget = y, t.relativeTargetOrigin = p, t.relativeParent = h);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: s,
      snapshot: n,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: s } = t.options;
    s && s();
  }
  t.options.transition = void 0;
}
function yu(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function vu(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function xu(t) {
  t.clearSnapshot();
}
function wi(t) {
  t.clearMeasurements();
}
function Tu(t) {
  t.isLayoutDirty = !1;
}
function bu(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Pi(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function wu(t) {
  t.resolveTargetDelta();
}
function Pu(t) {
  t.calcProjection();
}
function Su(t) {
  t.resetSkewAndRotation();
}
function Au(t) {
  t.removeLeadSnapshot();
}
function Si(t, e, n) {
  t.translate = B(e.translate, 0, n), t.scale = B(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Ai(t, e, n, s) {
  t.min = B(e.min, n.min, s), t.max = B(e.max, n.max, s);
}
function Cu(t, e, n, s) {
  Ai(t.x, e.x, n.x, s), Ai(t.y, e.y, n.y, s);
}
function Eu(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const Vu = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Ci = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), Ei = Ci("applewebkit/") && !Ci("chrome/") ? Math.round : G;
function Vi(t) {
  t.min = Ei(t.min), t.max = Ei(t.max);
}
function Mu(t) {
  Vi(t.x), Vi(t.y);
}
function ao(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Dc(xi(e), xi(n), 0.2);
}
function Ru(t) {
  var e;
  return t !== t.root && ((e = t.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const Du = oo({
  attachResizeListener: (t, e) => oe(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Ke = {
  current: void 0
}, lo = oo({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!Ke.current) {
      const t = new Du({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), Ke.current = t;
    }
    return Ke.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Lu = {
  pan: {
    Feature: Gc
  },
  drag: {
    Feature: Yc,
    ProjectionNode: lo,
    MeasureLayout: to
  }
};
function ku(t, e, n) {
  var s;
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let i = document;
    const o = (s = void 0) !== null && s !== void 0 ? s : i.querySelectorAll(t);
    return o ? Array.from(o) : [];
  }
  return Array.from(t);
}
function co(t, e) {
  const n = ku(t), s = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: s.signal
  };
  return [n, i, () => s.abort()];
}
function Mi(t) {
  return !(t.pointerType === "touch" || Wr());
}
function ju(t, e, n = {}) {
  const [s, i, o] = co(t, n), r = (a) => {
    if (!Mi(a))
      return;
    const { target: l } = a, c = e(l, a);
    if (typeof c != "function" || !l)
      return;
    const u = (h) => {
      Mi(h) && (c(h), l.removeEventListener("pointerleave", u));
    };
    l.addEventListener("pointerleave", u, i);
  };
  return s.forEach((a) => {
    a.addEventListener("pointerenter", r, i);
  }), o;
}
function Ri(t, e, n) {
  const { props: s } = t;
  t.animationState && s.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = s[i];
  o && L.postRender(() => o(e, ue(e)));
}
class Bu extends mt {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = ju(e, (n, s) => (Ri(this.node, s, "Start"), (i) => Ri(this.node, i, "End"))));
  }
  unmount() {
  }
}
class Ou extends mt {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ce(oe(this.node.current, "focus", () => this.onFocus()), oe(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const uo = (t, e) => e ? t === e ? !0 : uo(t, e.parentElement) : !1, Fu = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Iu(t) {
  return Fu.has(t.tagName) || t.tabIndex !== -1;
}
const Gt = /* @__PURE__ */ new WeakSet();
function Di(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function Ye(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Nu = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const s = Di(() => {
    if (Gt.has(n))
      return;
    Ye(n, "down");
    const i = Di(() => {
      Ye(n, "up");
    }), o = () => Ye(n, "cancel");
    n.addEventListener("keyup", i, e), n.addEventListener("blur", o, e);
  });
  n.addEventListener("keydown", s, e), n.addEventListener("blur", () => n.removeEventListener("keydown", s), e);
};
function Li(t) {
  return Qn(t) && !Wr();
}
function _u(t, e, n = {}) {
  const [s, i, o] = co(t, n), r = (a) => {
    const l = a.currentTarget;
    if (!Li(a) || Gt.has(l))
      return;
    Gt.add(l);
    const c = e(l, a), u = (m, p) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", d), !(!Li(m) || !Gt.has(l)) && (Gt.delete(l), typeof c == "function" && c(m, { success: p }));
    }, h = (m) => {
      u(m, l === window || l === document || n.useGlobalTarget || uo(l, m.target));
    }, d = (m) => {
      u(m, !1);
    };
    window.addEventListener("pointerup", h, i), window.addEventListener("pointercancel", d, i);
  };
  return s.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", r, i), a instanceof HTMLElement && (a.addEventListener("focus", (c) => Nu(c, i)), !Iu(a) && a.tabIndex === null && (a.tabIndex = 0));
  }), o;
}
function ki(t, e, n) {
  const { props: s } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && s.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = s[i];
  o && L.postRender(() => o(e, ue(e)));
}
class Uu extends mt {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = _u(e, (n, s) => (ki(this.node, s, "Start"), (i, { success: o }) => ki(this.node, i, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const pn = /* @__PURE__ */ new WeakMap(), Ge = /* @__PURE__ */ new WeakMap(), $u = (t) => {
  const e = pn.get(t.target);
  e && e(t);
}, zu = (t) => {
  t.forEach($u);
};
function Wu({ root: t, ...e }) {
  const n = t || document;
  Ge.has(n) || Ge.set(n, {});
  const s = Ge.get(n), i = JSON.stringify(e);
  return s[i] || (s[i] = new IntersectionObserver(zu, { root: t, ...e })), s[i];
}
function Hu(t, e, n) {
  const s = Wu(e);
  return pn.set(t, n), s.observe(t), () => {
    pn.delete(t), s.unobserve(t);
  };
}
const Ku = {
  some: 0,
  all: 1
};
class Yu extends mt {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: s, amount: i = "some", once: o } = e, r = {
      root: n ? n.current : void 0,
      rootMargin: s,
      threshold: typeof i == "number" ? i : Ku[i]
    }, a = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, o && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: h } = this.node.getProps(), d = c ? u : h;
      d && d(l);
    };
    return Hu(this.node.current, r, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Gu(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Gu({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const Xu = {
  inView: {
    Feature: Yu
  },
  tap: {
    Feature: Uu
  },
  focus: {
    Feature: Ou
  },
  hover: {
    Feature: Bu
  }
}, qu = {
  layout: {
    ProjectionNode: lo,
    MeasureLayout: to
  }
}, gn = { current: null }, ho = { current: !1 };
function Zu() {
  if (ho.current = !0, !!wn)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => gn.current = t.matches;
      t.addListener(e), e();
    } else
      gn.current = !1;
}
const Ju = [...Dr, z, dt], Qu = (t) => Ju.find(Rr(t)), th = /* @__PURE__ */ new WeakMap();
function eh(t, e, n) {
  for (const s in e) {
    const i = e[s], o = n[s];
    if (H(i))
      t.addValue(s, i), process.env.NODE_ENV === "development" && Ee(i.version === "12.6.2", `Attempting to mix Motion versions ${i.version} with 12.6.2 may not work as expected.`);
    else if (H(o))
      t.addValue(s, ie(i, { owner: t }));
    else if (o !== i)
      if (t.hasValue(s)) {
        const r = t.getValue(s);
        r.liveStyle === !0 ? r.jump(i) : r.hasAnimated || r.set(i);
      } else {
        const r = t.getStaticValue(s);
        t.addValue(s, ie(r !== void 0 ? r : i, { owner: t }));
      }
  }
  for (const s in n)
    e[s] === void 0 && t.removeValue(s);
  return e;
}
const ji = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class nh {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, s) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: s, reducedMotionConfig: i, blockInitialAnimation: o, visualState: r }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Xn, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const m = nt.now();
      this.renderScheduledAt < m && (this.renderScheduledAt = m, L.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c, onUpdate: u } = r;
    this.onUpdate = u, this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = e, this.props = n, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!o, this.isControllingVariants = Re(n), this.isVariantNode = zi(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: h, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const m in d) {
      const p = d[m];
      l[m] !== void 0 && H(p) && p.set(l[m], !1);
    }
  }
  mount(e) {
    this.current = e, th.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, s) => this.bindToMotionValue(s, n)), ho.current || Zu(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : gn.current, process.env.NODE_ENV !== "production" && Ee(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), ft(this.notifyUpdate), ft(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const s = Pt.has(e);
    s && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (a) => {
      this.latestValues[e] = a, this.props.onUpdate && L.preRender(this.notifyUpdate), s && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let r;
    window.MotionCheckAppearSync && (r = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), o(), r && r(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in kt) {
      const n = kt[e];
      if (!n)
        continue;
      const { isEnabled: s, Feature: i } = n;
      if (!this.features[e] && i && s(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const o = this.features[e];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : F();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let s = 0; s < ji.length; s++) {
      const i = ji[s];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, r = e[o];
      r && (this.propEventSubscriptions[i] = this.on(i, r));
    }
    this.prevMotionValues = eh(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const s = this.values.get(e);
    n !== s && (s && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && n !== void 0 && (s = ie(n === null ? void 0 : n, { owner: this }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var s;
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (s = this.getBaseTargetFromProps(this.props, e)) !== null && s !== void 0 ? s : this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (Vr(i) || vr(i)) ? i = parseFloat(i) : !Qu(i) && dt.test(n) && (i = Ar(e, n)), this.setBaseTarget(e, H(i) ? i.get() : i)), H(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: s } = this.props;
    let i;
    if (typeof s == "string" || typeof s == "object") {
      const r = On(this.props, s, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      r && (i = r[e]);
    }
    if (s && i !== void 0)
      return i;
    const o = this.getBaseTargetFromProps(this.props, e);
    return o !== void 0 && !H(o) ? o : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Un()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class fo extends nh {
  constructor() {
    super(...arguments), this.KeyframeResolver = Lr;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: s }) {
    delete n[e], delete s[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    H(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function sh(t) {
  return window.getComputedStyle(t);
}
class ih extends fo {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = tr;
  }
  readValueFromInstance(e, n) {
    if (Pt.has(n))
      return ll(e, n);
    {
      const s = sh(e), i = (Vn(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return qr(e, n);
  }
  build(e, n, s) {
    Dn(e, n, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return Fn(e, n, s);
  }
}
class rh extends fo {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = F, this.updateDimensions = () => {
      this.current && !this.renderState.dimensions && Qi(this.current, this.renderState);
    };
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (Pt.has(n)) {
      const s = Sr(n);
      return s && s.default || 0;
    }
    return n = er.has(n) ? n : En(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return sr(e, n, s);
  }
  onBindTransform() {
    this.current && !this.renderState.dimensions && L.postRender(this.updateDimensions);
  }
  build(e, n, s) {
    jn(e, n, this.isSVGTag, s.transformTemplate);
  }
  renderInstance(e, n, s, i) {
    nr(e, n, s, i);
  }
  mount(e) {
    this.isSVGTag = Bn(e.tagName), super.mount(e);
  }
}
const oh = (t, e) => kn(t) ? new rh(e) : new ih(e, {
  allowProjection: t !== Fi
}), ah = /* @__PURE__ */ Ea({
  ...wc,
  ...Xu,
  ...Lu,
  ...qu
}, oh), Xe = /* @__PURE__ */ zo(ah), lh = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z" })), ch = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "m19.46 8 .79-1.75L22 5.46a.5.5 0 0 0 0-.91l-1.75-.79L19.46 2a.5.5 0 0 0-.91 0l-.79 1.75-1.76.79a.5.5 0 0 0 0 .91l1.75.79.79 1.76c.18.39.74.39.92 0zM11.5 9.5 9.91 6c-.35-.78-1.47-.78-1.82 0L6.5 9.5 3 11.09c-.78.36-.78 1.47 0 1.82l3.5 1.59L8.09 18c.36.78 1.47.78 1.82 0l1.59-3.5 3.5-1.59c.78-.36.78-1.47 0-1.82L11.5 9.5zm7.04 6.5-.79 1.75-1.75.79a.5.5 0 0 0 0 .91l1.75.79.79 1.76a.5.5 0 0 0 .91 0l.79-1.75 1.76-.79a.5.5 0 0 0 0-.91l-1.75-.79-.79-1.76a.508.508 0 0 0-.92 0z" })), Bi = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 9h10c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1zm6 5H7c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm4-6H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z" })), uh = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M13 8.57a1.43 1.43 0 1 0 0 2.86 1.43 1.43 0 0 0 0-2.86z" }), /* @__PURE__ */ O.createElement("path", { d: "M13.21 3c-3.84-.11-7 2.87-7.19 6.64L4.1 12.2a.5.5 0 0 0 .4.8H6v3c0 1.1.9 2 2 2h1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3.68a7.004 7.004 0 0 0 4-6.58c-.14-3.62-3.18-6.63-6.79-6.74zM16 10c0 .13-.01.26-.02.39l.83.66c.08.06.1.16.05.25l-.8 1.39c-.05.09-.16.12-.24.09l-.99-.4c-.21.16-.43.29-.67.39L14 13.83c-.01.1-.1.17-.2.17h-1.6c-.1 0-.18-.07-.2-.17l-.15-1.06c-.25-.1-.47-.23-.68-.39l-.99.4c-.09.03-.2 0-.25-.09l-.8-1.39a.19.19 0 0 1 .05-.25l.84-.66c-.01-.13-.02-.26-.02-.39s.02-.27.04-.39l-.85-.66c-.08-.06-.1-.16-.05-.26l.8-1.38c.05-.09.15-.12.24-.09l1 .4c.2-.15.43-.29.67-.39L12 6.17c.02-.1.1-.17.2-.17h1.6c.1 0 .18.07.2.17l.15 1.06c.24.1.46.23.67.39l1-.4c.09-.03.2 0 .24.09l.8 1.38a.2.2 0 0 1-.05.26l-.85.66c.03.12.04.25.04.39z" })), hh = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("circle", { cx: 10, cy: 9, r: 4 }), /* @__PURE__ */ O.createElement("path", { d: "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 0 0 2 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zm3-13.8c-.43-.43-1.14-.39-1.51.09-1.5 1.93-3.35 6.72 0 11.03.37.48 1.08.52 1.5.09.35-.35.39-.91.09-1.3-1.17-1.5-2.64-5.23 0-8.61a.98.98 0 0 0-.08-1.3zm3.01 4.1c.23-.4.19-.9-.14-1.22-.47-.48-1.26-.37-1.59.21-1.15 2-.57 4.03.01 5.04.33.57 1.11.67 1.58.21.33-.33.36-.84.13-1.25-.25-.44-.74-1.69.01-2.99z" })), fh = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M5 11h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm0 10h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm8-16v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2zm2 16h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2z" })), dh = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M12 11.55c-1.82-1.7-4.12-2.89-6.68-3.35C4.11 7.99 3 8.95 3 10.18v6.24c0 1.68.72 2.56 1.71 2.69 2.5.32 4.77 1.35 6.63 2.87.35.29.92.32 1.27.04 1.87-1.53 4.16-2.58 6.68-2.9.94-.13 1.71-1.06 1.71-2.02v-6.92c0-1.23-1.11-2.19-2.32-1.98-2.56.46-4.86 1.65-6.68 3.35zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z" })), mh = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M3 6c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1H4v2c0 .55-.45 1-1 1zm14-4c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1zM3 18c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H4v-2c0-.55-.45-1-1-1zm14 4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1zm2-4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v12zM9 9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1zm0 3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1zm0 3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1z" })), ph = (t) => /* @__PURE__ */ O.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ O.createElement("path", { d: "M14.59 2.59c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm-2-6V3.5L18.5 9H14c-.55 0-1-.45-1-1z" })), Th = (t) => {
  const [e, n] = qe(!1);
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx(Bo, { children: e && /* @__PURE__ */ V.jsx(yh, { onClose: () => n(!1), env: t.env || "prod" }) }),
    /* @__PURE__ */ V.jsxs("div", { className: Ht.NavBarContainer, children: [
      /* @__PURE__ */ V.jsx(
        "button",
        {
          className: Ht.IconButton,
          onClick: () => {
            n(!0);
          },
          children: /* @__PURE__ */ V.jsx(lh, {})
        }
      ),
      /* @__PURE__ */ V.jsxs("h1", { className: Ht.AppTitle, children: [
        "Ipsos | ",
        t.appTitle
      ] }),
      /* @__PURE__ */ V.jsxs("div", { className: Ht.NavBarActions, children: [
        t.unauthenticatedActions,
        t.isAuthenticated && /* @__PURE__ */ V.jsx(V.Fragment, { children: /* @__PURE__ */ V.jsx(
          "button",
          {
            onClick: t.onLogoutClick,
            className: Ht.IconButton,
            "aria-label": "Logout",
            children: /* @__PURE__ */ V.jsx(Ro, {})
          }
        ) })
      ] })
    ] })
  ] });
}, gh = (t) => [
  {
    icon: /* @__PURE__ */ V.jsx(Bi, {}),
    label: "Chat",
    url: `https://${t}.ipsosfacto.com/chatPage`
  },
  {
    icon: /* @__PURE__ */ V.jsx(uh, {}),
    label: "Knowledge Companion",
    url: `https://${t}.ipsosfacto.com/knowledgeCompanionAgent`
  },
  {
    icon: /* @__PURE__ */ V.jsx(Bi, {}),
    label: "Chat Harmoni (Beta)",
    url: "https://chatharmoni.online"
  },
  {
    icon: /* @__PURE__ */ V.jsx(ch, {}),
    label: "Social Signals",
    url: "https://app.synthesio.com/dashboard-v5/client/4114/workspaces/38469"
  },
  {
    icon: /* @__PURE__ */ V.jsx(hh, {}),
    label: "Transcriptions",
    url: `https://${t}.ipsosfacto.com/transcriptions`
  },
  {
    icon: /* @__PURE__ */ V.jsx(fh, {}),
    label: "Coding",
    url: `https://${t}.ipsosfacto.com/coding`
  },
  {
    icon: /* @__PURE__ */ V.jsx(dh, {}),
    label: "Prompt library",
    url: `https://${t}.ipsosfacto.com/library`
  },
  {
    icon: /* @__PURE__ */ V.jsx(mh, {}),
    label: "Documentation",
    url: `https://${t}.ipsosfacto.com/documentation`
  },
  {
    icon: /* @__PURE__ */ V.jsx(ph, {}),
    label: "Document Deep Analysis",
    url: `https://${t}.ipsosfacto.com/documentReviewer`
  }
], yh = (t) => /* @__PURE__ */ V.jsx(
  Xe.div,
  {
    "aria-label": "Click to close the menu",
    onClick: t.onClose,
    initial: {
      opacity: 0
    },
    style: {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: "rgba(0, 0, 0, 0.5)",
      zIndex: 9999,
      backdropFilter: "blur(5px)"
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    children: /* @__PURE__ */ V.jsx(
      Xe.div,
      {
        onClick: (e) => e.stopPropagation(),
        initial: {
          opacity: 0,
          translateX: "-100%"
        },
        animate: {
          opacity: 1,
          translateX: 0
        },
        exit: {
          opacity: 0,
          translateX: "-100%"
        },
        style: {
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          width: "350px",
          background: "rgb(3, 22, 45)",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
          padding: "20px 0",
          overflow: "hidden",
          overflowY: "auto"
        },
        transition: {
          easing: "easeInOut"
        },
        children: /* @__PURE__ */ V.jsx("ul", { style: { listStyle: "none", padding: 0 }, children: gh(t.env).map((e) => /* @__PURE__ */ V.jsxs(
          Xe.li,
          {
            whileHover: { scale: 1.1, originX: 0 },
            style: {
              display: "flex",
              alignItems: "center",
              color: "white",
              cursor: "pointer",
              padding: "15px 40px",
              borderBottom: "1px solid rgba(46, 203, 202, 0.23)"
            },
            role: "button",
            onClick: () => {
              window.open(e.url, "_blank", "noopener");
            },
            "aria-label": `New tab: ${e.label}`,
            children: [
              /* @__PURE__ */ V.jsx("span", { style: { marginRight: "10px", fill: "currentcolor" }, children: e.icon }),
              e.label
            ]
          },
          e.label
        )) })
      }
    )
  }
);
export {
  Th as NavBar
};
